import { React, useEffect, useState, useRef } from 'react'
import { Container, Nav, Navbar, Offcanvas, Row, Stack, Table, Modal, Button, Form, Tab, Tabs, Card, ListGroup, Dropdown, Alert } from 'react-bootstrap';
import Login from '../Components/Admin/Login';
import { onAuthStateChanged } from 'firebase/auth';
import Navigation from '../Components/Admin/Navigation';
import { db, auth } from '../utils/firebase'
import { collection, getDocs, doc, updateDoc, addDoc, deleteDoc, setDoc, onSnapshot, collectionGroup } from 'firebase/firestore';
import { getStorage, ref, listAll } from 'firebase/storage';
import moment from 'moment';
import UkiesAssets from '../Components/Admin/UkiesAssets';
import { v4 as uuidv4 } from 'uuid';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export default function UkiesAdminSeries(props) {
    const [ token, setToken ] = useState(localStorage.getItem('ukies-webinars-accessToken'))
    const [ user, setUser ] = useState(JSON.parse(localStorage.getItem('ukies-webinars-admin')))
    const [ series, setSeries ] = useState([])
    const [ seriesLoading, setSeriesLoading ] = useState(false)
    const [ selected, setSelected ] = useState()
    const [ showModal, setShowModal ] = useState(false)
    const [ formData, setFormData ] = useState({})
    const [ saving, setSaving ] = useState(false)
    const [ activeTab, setActiveTab ] = useState('details')
    const [ products, setProducts ] = useState([])
    const [ filteredProducts, setFilteredProducts ] = useState([])
    const [ productSearchTerm, setProductSearchTerm ] = useState('')
    const [ showProductDropdown, setShowProductDropdown ] = useState(false)
    const [ showAlert, setShowAlert ] = useState(false)
    const [ alertMessage, setAlertMessage ] = useState('')
    const [ alertType, setAlertType ] = useState('success')
    const [ availabilityType, setAvailabilityType ] = useState('months')
    const [ isTemporaryFree, setIsTemporaryFree ] = useState(false)
    const datePickerRef = useRef(null)
    const [ tagsDisplayValue, setTagsDisplayValue ] = useState('')
    const [ showThumbnailAssets, setShowThumbnailAssets ] = useState(false)
    const [ showImageAssets, setShowImageAssets ] = useState(false)
    const [ showPreviewModal, setShowPreviewModal ] = useState(false)
    const [ previewImage, setPreviewImage ] = useState('')
    const [ sourceCodeMode, setSourceCodeMode ] = useState(false)
    const [ activeModuleIndex, setActiveModuleIndex ] = useState(0)
    const [ moduleFormData, setModuleFormData ] = useState({})
    const [ modules, setModules ] = useState([])
    const [ moduleTagsDisplayValue, setModuleTagsDisplayValue ] = useState('')
    const [ moduleSourceCodeMode, setModuleSourceCodeMode ] = useState(false)
    const [ savingModule, setSavingModule ] = useState(false)
    const [ showModuleThumbnailAssets, setShowModuleThumbnailAssets ] = useState(false)
    const [ activeFileIndex, setActiveFileIndex ] = useState(0)
    const [ fileFormData, setFileFormData ] = useState({})
    const [ files, setFiles ] = useState([])
    const [ fileTagsDisplayValue, setFileTagsDisplayValue ] = useState('')
    const [ fileSourceCodeMode, setFileSourceCodeMode ] = useState(false)
    const [ savingFile, setSavingFile ] = useState(false)
    const [ showFileThumbnailAssets, setShowFileThumbnailAssets ] = useState(false)
    const [ showCommentsFilter, setShowCommentsFilter ] = useState(true)
    const [ showDeletedComments, setShowDeletedComments ] = useState(false)
    const [ editingComment, setEditingComment ] = useState(null)
    const [ editCommentData, setEditCommentData ] = useState({})
    const [ savingComment, setSavingComment ] = useState(false)
    const [ activeCommentModuleIndex, setActiveCommentModuleIndex ] = useState(0)
    const [ moduleComments, setModuleComments ] = useState({})
    const [ refreshing, setRefreshing ] = useState(false)
    const [ commentListeners, setCommentListeners ] = useState({})
    const [ deleteEnabled, setDeleteEnabled ] = useState(false)
    const [ videoFolders, setVideoFolders ] = useState([])
    const [ videoFoldersLoading, setVideoFoldersLoading ] = useState(false)
    const [ storageFiles, setStorageFiles ] = useState([])
    const [ storageFilesLoading, setStorageFilesLoading ] = useState(false)
    const editorRef = useRef(null)
    const moduleEditorRef = useRef(null)
    const fileEditorRef = useRef(null)
    const [ authReady, setAuthReady ] = useState(false)

    // Token for API calls
    const apiToken = process.env.REACT_APP_UKIES_API_TOKEN;

    // Helper function to format timestamps (handles both Firestore Timestamp and ISO string)
    const formatTimestamp = (timestamp) => {
        if (!timestamp) return '';
        const momentObj = timestamp.seconds ? moment.unix(timestamp.seconds) : moment(timestamp);
        return `${momentObj.fromNow()} (${momentObj.format('DD-MM-YYYY HH:mm')})`;
    };

    // Fetch video folders from Firebase Storage
    const fetchVideoFolders = async () => {
        if (videoFolders.length > 0) return; // Only fetch once
        
        setVideoFoldersLoading(true);
        try {
            const storage = getStorage();
            const videosRef = ref(storage, 'videos');
            const result = await listAll(videosRef);
            
            const folders = [];
            for (const folderRef of result.prefixes) {
                const folderName = folderRef.name;
                // Construct the full path to the .m3u8 file in this folder
                const m3u8Path = `/videos/${folderName}/master.m3u8`;
                folders.push({
                    name: folderName,
                    path: m3u8Path
                });
            }
            
            setVideoFolders(folders);
        } catch (error) {
            console.error('Error fetching video folders:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het ophalen van video folders.');
            setAlertType('danger');
        } finally {
            setVideoFoldersLoading(false);
        }
    };

    // Fetch files from Firebase Storage /files/ folder
    const fetchStorageFiles = async () => {
        if (storageFiles.length > 0) return; // Only fetch once
        
        setStorageFilesLoading(true);
        try {
            const storage = getStorage();
            const filesRef = ref(storage, 'files');
            const result = await listAll(filesRef);
            
            const files = [];
            for (const itemRef of result.items) {
                const fileName = itemRef.name;
                const filePath = `/files/${fileName}`;
                files.push({
                    name: fileName,
                    path: filePath
                });
            }
            
            setStorageFiles(files);
        } catch (error) {
            console.error('Error fetching storage files:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het ophalen van bestanden.');
            setAlertType('danger');
        } finally {
            setStorageFilesLoading(false);
        }
    };

    // Fetch products from API
    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await fetch('https://ukies-api-search.eliteswitch.com/indexes/webshops_products/search', {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer 4b36930f2bd83b21720d21796590bd09d4952019891f937f49295130ffbecc4e',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "q": null,
                        "sort": ["id:desc"],
                        "matchingStrategy": "all",
                        "facets": ["*"],
                        "filter": [["categories.id = '12'"],["product_status = 'active'"]],
                        "limit": 1000
                    })
                });

                if (response.ok) {
                    const data = await response.json();
                    setProducts(data.hits || []);
                    setFilteredProducts(data.hits || []);
                } else {
                    console.error('Failed to fetch products:', response.statusText);
                }
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        };

        if (products.length === 0) {
            fetchProducts();
        }
    }, [products.length]);

    // Filter products based on search term
    useEffect(() => {
        if (productSearchTerm === '') {
            setFilteredProducts(products);
        } else {
            const filtered = products.filter(product => 
                product.title.toLowerCase().includes(productSearchTerm.toLowerCase()) ||
                product.id.toString().includes(productSearchTerm)
            );
            setFilteredProducts(filtered);
        }
    }, [productSearchTerm, products]);

    useEffect(() => {
        const getSeries = async () => {
            setSeriesLoading(true)
            
            try {
                // Fetch all data in parallel using collection groups - much more efficient!
                const [seriesSnapshot, modulesSnapshot, filesSnapshot, commentsSnapshot] = await Promise.all([
                    getDocs(collection(db, 'series')),
                    getDocs(collectionGroup(db, 'modules')),
                    getDocs(collectionGroup(db, 'files')),
                    getDocs(collectionGroup(db, 'comments'))
                ]);

                // Process series
                const result = [];
                for (const doc of seriesSnapshot.docs) {
                    const seriesItem = doc.data();
                    seriesItem.id = doc.id; // Add document ID for updates
                    seriesItem.modules = []; // Initialize empty arrays
                    seriesItem.files = [];
                    seriesItem.totalComments = 0;
                    seriesItem.unreadComments = 0;
                    seriesItem.deletedComments = 0;
                    result.push(seriesItem);
                }

                // Create a map for quick series lookup
                const seriesMap = new Map(result.map(series => [series.id, series]));

                // Process modules and add to corresponding series
                modulesSnapshot.docs.forEach(doc => {
                    const moduleData = doc.data();
                    const seriesId = doc.ref.parent.parent.id; // Get parent series ID
                    
                    if (seriesMap.has(seriesId)) {
                        seriesMap.get(seriesId).modules.push(moduleData);
                    }
                });

                // Process files and add to corresponding series
                filesSnapshot.docs.forEach(doc => {
                    const fileData = doc.data();
                    const seriesId = doc.ref.parent.parent.id; // Get parent series ID
                    
                    if (seriesMap.has(seriesId)) {
                        seriesMap.get(seriesId).files.push(fileData);
                    }
                });

                // Process comments and calculate counts for each series
                commentsSnapshot.docs.forEach(doc => {
                    const commentData = doc.data();
                    // Path: series/{seriesId}/modules/{moduleId}/comments/{commentId}
                    const seriesId = doc.ref.parent.parent.parent.parent.id;
                    
                    if (seriesMap.has(seriesId)) {
                        const series = seriesMap.get(seriesId);
                        
                        // Count comments
                        if (!commentData.deleted) {
                            series.totalComments++;
                            if (!(commentData.response || commentData.notResponding)) {
                                series.unreadComments++;
                            }
                        } else {
                            series.deletedComments++;
                        }
                    }
                });

                setSeries([...result])
            } catch (error) {
                console.error('Error fetching series data:', error);
                setSeries([]);
            } finally {
                setSeriesLoading(false)
            }
        }
        // Only run getSeries when auth is ready AND we don't have series yet
        if(authReady && series.length < 1) {
            getSeries()
        }
    },[authReady]) // Add authReady as dependency

    // Handle opening modal and setting form data
    const handleRowClick = (seriesItem) => {
        // console.log('Selected series:', seriesItem); // Log to see all available fields
        setSelected(seriesItem);
        
        // Generate productLink from productId if it exists
        const productLink = seriesItem.productId 
            ? `https://www.ukies.nl/product/${seriesItem.productId}/`
            : seriesItem.productLink || '';
        
        // Determine availability type based on current data or use stored value
        let availType = seriesItem.availability || 'months';
        if (!seriesItem.availability) {
            // Legacy support: derive from existing fields if availability field doesn't exist
            if (seriesItem.isFree) {
                availType = seriesItem.freeRequiresSignup ? 'free-signup' : 'free';
            }
        }
        setAvailabilityType(availType);
        
        setFormData({
            availability: availType,
            productId: seriesItem.productId || 0,
            uuid: seriesItem.uuid || '',
            name: seriesItem.name || '',
            shortDesc: seriesItem.shortDesc || '',
            desciption: seriesItem.desciption || '', // Note: typo in field name from API
            type: seriesItem.type || '',
            contentType: seriesItem.contentType || '',
            availabilityInMonths: seriesItem.availabilityInMonths || 0,
            isFree: seriesItem.isFree || false,
            freeRequiresSignup: seriesItem.freeRequiresSignup || false,
            isTemporaryFree: seriesItem.isTemporaryFree || false,
            freeUntil: seriesItem.freeUntil ? new Date(seriesItem.freeUntil) : null,
            tags: seriesItem.tags || [],
            length: calculateSeriesLength(seriesItem.modules || []),
            thumbnail: seriesItem.thumbnail || '',
            image: seriesItem.image || '',
            imagePositionX: seriesItem.imagePositionX || 50,
            imagePositionY: seriesItem.imagePositionY || 50,
            productLink: productLink,
            alternativeLink: seriesItem.alternativeLink || '',
            enabled: seriesItem.enabled !== undefined ? seriesItem.enabled : true,
            moduleCount: seriesItem.moduleCount ?? (seriesItem.modules ? seriesItem.modules.length : 0),
            fileCount: seriesItem.fileCount ?? (seriesItem.files ? seriesItem.files.length : 0)
        });
        
        // Set temporary free state
        setIsTemporaryFree(seriesItem.isTemporaryFree || false);
        
        // Set tags display value
        const tagsDisplay = seriesItem.tags ? seriesItem.tags.map(tag => tag.label || '').join(', ') : '';
        setTagsDisplayValue(tagsDisplay);
        
        // Initialize modules data
        setModules(seriesItem.modules || []);
        setActiveModuleIndex(0);
        if (seriesItem.modules && seriesItem.modules.length > 0) {
            setModuleFormData(seriesItem.modules[0]);
            // Set initial module tags display value
            const moduleTagsDisplay = seriesItem.modules[0].tags ? seriesItem.modules[0].tags.map(tag => tag.label || '').join(', ') : '';
            setModuleTagsDisplayValue(moduleTagsDisplay);
        } else {
            setModuleFormData({});
            setModuleTagsDisplayValue('');
        }
        
        // Initialize files data
        setFiles(seriesItem.files || []);
        setActiveFileIndex(0);
        if (seriesItem.files && seriesItem.files.length > 0) {
            setFileFormData(seriesItem.files[0]);
            // Set initial file tags display value
            const fileTagsDisplay = seriesItem.files[0].tags ? seriesItem.files[0].tags.map(tag => tag.label || '').join(', ') : '';
            setFileTagsDisplayValue(fileTagsDisplay);
        } else {
            setFileFormData({});
            setFileTagsDisplayValue('');
        }
        
        // Set product search term based on current productId
        const currentProduct = products.find(p => p.id === seriesItem.productId);
        setProductSearchTerm(currentProduct ? currentProduct.title : '');
        
        // Set up real-time comment listeners for all modules (only if auth is ready)
        if (authReady) {
            setupCommentListeners(seriesItem);
        }
        
        // Fetch video folders when modal opens
        fetchVideoFolders();
        
        // Fetch storage files when modal opens
        fetchStorageFiles();
        
        setShowModal(true);
        setActiveTab('details');
        setActiveCommentModuleIndex(0);
    };

    // Set up real-time listeners for module comments
    const setupCommentListeners = (seriesItem) => {
        // Don't set up listeners if auth isn't ready
        if (!authReady) {
            return;
        }
        
        // Clean up existing listeners first
        cleanupCommentListeners();
        
        const newListeners = {};
        const comments = {};
        
        seriesItem.modules.forEach(module => {
            try {
                const commentsRef = collection(db, 'series', seriesItem.id, 'modules', module.uuid, 'comments');
                const unsubscribe = onSnapshot(commentsRef, (snapshot) => {
                    const moduleComments = snapshot.docs.map(commentDoc => commentDoc.data());
                    // Sort comments by pinned first (true before false), then by timestamp (newest first)
                    moduleComments.sort((a, b) => {
                        // First sort by pinned status (pinned comments first)
                        if (a.pinned === true && b.pinned !== true) return -1;
                        if (a.pinned !== true && b.pinned === true) return 1;
                        
                        // Then sort by timestamp (newest first)
                        const timestampA = a.timestamp?.seconds || 0;
                        const timestampB = b.timestamp?.seconds || 0;
                        return timestampB - timestampA;
                    });
                    
                    // console.log(`Comments for module ${module.uuid}:`, moduleComments.map(c => ({
                    //     user: c.user,
                    //     pinned: c.pinned,
                    //     timestamp: c.timestamp?.seconds,
                    //     comment: c.comment?.substring(0, 50) + '...'
                    // })));
                    
                    setModuleComments(prev => ({
                        ...prev,
                        [module.uuid]: moduleComments
                    }));
                });
                
                newListeners[module.uuid] = unsubscribe;
                comments[module.uuid] = []; // Initialize empty until data loads
            } catch (error) {
                console.error(`Error setting up comment listener for module ${module.uuid}:`, error);
                comments[module.uuid] = [];
            }
        });
        
        setCommentListeners(newListeners);
        setModuleComments(comments);
    };

    // Clean up comment listeners
    const cleanupCommentListeners = () => {
        Object.values(commentListeners).forEach(unsubscribe => {
            if (typeof unsubscribe === 'function') {
                unsubscribe();
            }
        });
        setCommentListeners({});
    };

    // Load comments for all modules (fallback for non-real-time scenarios)
    const loadModuleComments = async (seriesItem) => {
        const comments = {};
        for (const module of seriesItem.modules) {
            try {
                const commentsSnapshot = await getDocs(collection(db, 'series', seriesItem.id, 'modules', module.uuid, 'comments'));
                const moduleComments = commentsSnapshot.docs.map(commentDoc => commentDoc.data());
                // Sort comments by pinned first (true before false), then by timestamp (newest first)
                moduleComments.sort((a, b) => {
                    // First sort by pinned status (pinned comments first)
                    if (a.pinned === true && b.pinned !== true) return -1;
                    if (a.pinned !== true && b.pinned === true) return 1;
                    
                    // Then sort by timestamp (newest first)
                    const timestampA = a.timestamp?.seconds || 0;
                    const timestampB = b.timestamp?.seconds || 0;
                    return timestampB - timestampA;
                });
                comments[module.uuid] = moduleComments;
            } catch (error) {
                console.error(`Error loading comments for module ${module.uuid}:`, error);
                comments[module.uuid] = [];
            }
        }
        setModuleComments(comments);
    };

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : (type === 'number' ? parseInt(value) || 0 : value)
        }));
    };

    // Handle product selection
    const handleProductSelect = (product) => {
        const productLink = `https://www.ukies.nl/product/${product.id}/`;
        setFormData(prev => ({ 
            ...prev, 
            productId: product.id,
            productLink: productLink
        }));
        setProductSearchTerm(product.title);
        setShowProductDropdown(false);
    };

    // Handle product search input
    const handleProductSearch = (e) => {
        setProductSearchTerm(e.target.value);
        setShowProductDropdown(true);
    };

    // Handle description change from contentEditable
    const handleDescriptionChange = (e) => {
        const content = e.target.innerHTML;
        // Don't save placeholder text
        if (content === '<p>Voer hier de beschrijving in...</p>') {
            setFormData(prev => ({ ...prev, desciption: '' }));
        } else {
            setFormData(prev => ({ ...prev, desciption: content }));
        }
    };

    // Handle editor click to clear placeholder
    const handleEditorClick = () => {
        if (editorRef.current && editorRef.current.innerHTML === '<p>Voer hier de beschrijving in...</p>') {
            editorRef.current.innerHTML = '<p><br></p>';
            // Place cursor at beginning
            const range = document.createRange();
            const selection = window.getSelection();
            range.setStart(editorRef.current.firstChild, 0);
            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    };

    // Handle tags input - expects array of objects with label and color
    const handleTagsChange = (e) => {
        const inputValue = e.target.value;
        // console.log('Tags input changed:', inputValue);
        
        setTagsDisplayValue(inputValue);
        
        const tagStrings = inputValue.split(',').map(tag => tag.trim()).filter(tag => tag);
        const tags = tagStrings.map(label => ({ label, color: 'normal' }));
        
        // console.log('Processed tags:', tags);
        setFormData(prev => ({ ...prev, tags }));
    };

    // Handle availability type change
    const handleAvailabilityTypeChange = (e) => {
        const type = e.target.value;
        setAvailabilityType(type);
        
        setFormData(prev => {
            let updatedData = {
                ...prev,
                availability: type
            };
            
            if (type === 'months') {
                // For months, set based on temporary free status
                updatedData.isFree = prev.isTemporaryFree || false;
                updatedData.freeRequiresSignup = prev.isTemporaryFree ? (prev.freeRequiresSignup || false) : false;
                updatedData.availabilityInMonths = prev.availabilityInMonths || 0;
            } else if (type === 'free') {
                updatedData.availabilityInMonths = null;
                updatedData.isFree = true;
                updatedData.freeRequiresSignup = false;
                // Clear temporary free settings when switching to regular free
                updatedData.isTemporaryFree = false;
                updatedData.freeUntil = null;
            } else if (type === 'free-signup') {
                updatedData.availabilityInMonths = null;
                updatedData.isFree = true;
                updatedData.freeRequiresSignup = true;
                // Clear temporary free settings when switching to free with signup
                updatedData.isTemporaryFree = false;
                updatedData.freeUntil = null;
            }
            
            return updatedData;
        });
        
        // Reset temporary free state when switching away from months
        if (type !== 'months') {
            setIsTemporaryFree(false);
        }
    };

    // Handle temporary free toggle
    const handleTemporaryFreeToggle = () => {
        const newValue = !isTemporaryFree;
        setIsTemporaryFree(newValue);
        setFormData(prev => ({
            ...prev,
            isTemporaryFree: newValue,
            // Only set isFree when availability is months and temporary free is enabled
            isFree: prev.availability === 'months' ? newValue : prev.isFree,
            // Automatically set freeRequiresSignup to true when enabling temporary free
            freeRequiresSignup: newValue ? true : false,
            freeUntil: newValue ? prev.freeUntil : null
        }));
    };

    // Handle temporary free signup toggle
    const handleTemporaryFreeSignupToggle = () => {
        setFormData(prev => ({
            ...prev,
            freeRequiresSignup: !prev.freeRequiresSignup
        }));
    };

    // Handle free until date change
    const handleFreeUntilDateChange = (date) => {
        setFormData(prev => ({
            ...prev,
            freeUntil: date
        }));
    };

    // Handle enabled toggle
    const handleEnabledToggle = () => {
        setFormData(prev => ({
            ...prev,
            enabled: !prev.enabled
        }));
    };

    // Handle form submission
    const handleSave = async () => {
        if (!selected || !selected.id) return;
        
        setSaving(true);
        try {
            // Save current module and file data before saving
            if (modules[activeModuleIndex]) {
                const updatedModules = [...modules];
                updatedModules[activeModuleIndex] = { ...moduleFormData };
                setModules(updatedModules);
            }
            
            if (files[activeFileIndex]) {
                const updatedFiles = [...files];
                updatedFiles[activeFileIndex] = { ...fileFormData };
                setFiles(updatedFiles);
            }

                    const seriesRef = doc(db, 'series', selected.id);
        const updateData = { ...formData };
        
        // Update counts and length based on current modules and files arrays
        updateData.moduleCount = modules.length;
        updateData.fileCount = files.length;
        updateData.length = calculateSeriesLength(modules);
        
        // Convert string numbers to actual numbers
        if (updateData.productId) updateData.productId = parseInt(updateData.productId);
        if (updateData.availabilityInMonths) updateData.availabilityInMonths = parseInt(updateData.availabilityInMonths);
        
        // Convert date to ISO string for Firestore
        if (updateData.freeUntil) {
            updateData.freeUntil = updateData.freeUntil.toISOString();
        }
            
            await updateDoc(seriesRef, updateData);

            // Update modules subcollection
            const modulesCollectionRef = collection(db, 'series', selected.id, 'modules');
            
            // First, get all existing modules and delete them
            const existingModulesSnapshot = await getDocs(modulesCollectionRef);
            const deleteModulePromises = existingModulesSnapshot.docs.map(doc => deleteDoc(doc.ref));
            await Promise.all(deleteModulePromises);
            
            // Then add all current modules using UUID as document ID
            const currentModules = modules[activeModuleIndex] ? 
                [...modules.slice(0, activeModuleIndex), moduleFormData, ...modules.slice(activeModuleIndex + 1)] : 
                modules;
            
            // Update all modules with the new series name if it was changed
            const updatedModules = currentModules.map(module => ({
                ...module,
                series: updateData.name || module.series
            }));
                
            const setModulePromises = updatedModules.map(module => {
                const { uuid, ...moduleData } = module;
                const moduleDocRef = doc(db, 'series', selected.id, 'modules', uuid);
                return setDoc(moduleDocRef, { uuid, ...moduleData });
            });
            await Promise.all(setModulePromises);

            // Update files subcollection
            const filesCollectionRef = collection(db, 'series', selected.id, 'files');
            
            // First, get all existing files and delete them
            const existingFilesSnapshot = await getDocs(filesCollectionRef);
            const deleteFilePromises = existingFilesSnapshot.docs.map(doc => deleteDoc(doc.ref));
            await Promise.all(deleteFilePromises);
            
            // Then add all current files using UUID as document ID
            const currentFiles = files[activeFileIndex] ? 
                [...files.slice(0, activeFileIndex), fileFormData, ...files.slice(activeFileIndex + 1)] : 
                files;
                
            const setFilePromises = currentFiles.map(file => {
                const { uuid, ...fileData } = file;
                const fileDocRef = doc(db, 'series', selected.id, 'files', uuid);
                return setDoc(fileDocRef, { uuid, ...fileData });
            });
            await Promise.all(setFilePromises);

            // Update local state
            setSeries(prev => prev.map(s => 
                s.id === selected.id 
                    ? { ...s, ...updateData, modules: updatedModules, files: currentFiles }
                    : s
            ));

            setShowModal(false);
            setSelected(null);
            setShowAlert(true);
            setAlertMessage('Serie succesvol bijgewerkt!');
            setAlertType('success');
        } catch (error) {
            console.error('Error updating series:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het bijwerken van de serie. Probeer het opnieuw.');
            setAlertType('danger');
        } finally {
            setSaving(false);
        }
    };

    // Handle modal close
    const handleClose = () => {
        setShowModal(false);
        setSelected(null);
        setFormData({});
        setIsTemporaryFree(false);
        setActiveTab('details');
        setShowProductDropdown(false);
        setProductSearchTerm('');
        setTagsDisplayValue('');
        setShowThumbnailAssets(false);
        setShowImageAssets(false);
        setShowPreviewModal(false);
        setPreviewImage('');
        setSourceCodeMode(false);
        setActiveModuleIndex(0);
        setModuleFormData({});
        setModules([]);
        setModuleTagsDisplayValue('');
        setModuleSourceCodeMode(false);
        setSavingModule(false);
        setShowModuleThumbnailAssets(false);
        setActiveFileIndex(0);
        setFileFormData({});
        setFiles([]);
        setFileTagsDisplayValue('');
        setFileSourceCodeMode(false);
        setSavingFile(false);
        setShowFileThumbnailAssets(false);
        setShowCommentsFilter(true);
        setShowDeletedComments(false);
        setEditingComment(null);
        setEditCommentData({});
        setSavingComment(false);
        setActiveCommentModuleIndex(0);
        setModuleComments({});
        setDeleteEnabled(false);
        setVideoFolders([]);
        setVideoFoldersLoading(false);
        setStorageFiles([]);
        setStorageFilesLoading(false);
        
        // Clean up comment listeners
        cleanupCommentListeners();
    };

    // Add custom styles for the switch
    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            /* Override Bootstrap primary color */
            .btn-primary {
                background-color: #3b4f46 !important;
                border-color: #3b4f46 !important;
            }
            .btn-primary:hover {
                background-color: #2d3d35 !important;
                border-color: #2d3d35 !important;
            }
            .btn-primary:focus, .btn-primary.focus {
                background-color: #2d3d35 !important;
                border-color: #2d3d35 !important;
                box-shadow: 0 0 0 0.2rem rgba(59, 79, 70, 0.5) !important;
            }
            .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active {
                background-color: #243028 !important;
                border-color: #243028 !important;
            }
            .btn-outline-primary {
                color: #3b4f46 !important;
                border-color: #3b4f46 !important;
            }
            .btn-outline-primary:hover {
                background-color: #3b4f46 !important;
                border-color: #3b4f46 !important;
            }
            .btn-outline-primary:focus, .btn-outline-primary.focus {
                box-shadow: 0 0 0 0.2rem rgba(59, 79, 70, 0.5) !important;
            }
            .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active {
                background-color: #3b4f46 !important;
                border-color: #3b4f46 !important;
            }

            /* Tab navigation styling */
            .nav-tabs {
                border-bottom: 2px solid #3b4f46 !important;
            }
            .nav-tabs .nav-link.active {
                background-color: #3b4f46 !important;
                border-color: #3b4f46 #3b4f46 transparent !important;
                color: #fff !important;
            }
            .nav-tabs .nav-link.active:hover {
                background-color: #3b4f46 !important;
                border-color: #3b4f46 #3b4f46 transparent !important;
                color: #fff !important;
            }
            .nav-tabs .nav-link.active:focus {
                background-color: #3b4f46 !important;
                border-color: #3b4f46 #3b4f46 transparent !important;
                color: #fff !important;
            }
            .nav-tabs .nav-link.active:active {
                background-color: #3b4f46 !important;
                border-color: #3b4f46 #3b4f46 transparent !important;
                color: #fff !important;
            }
            .nav-tabs .nav-link:hover {
                border-color: #3b4f46 #3b4f46 #dee2e6 !important;
                color: #3b4f46 !important;
            }
            .nav-tabs .nav-link:focus {
                border-color: #3b4f46 #3b4f46 #dee2e6 !important;
                color: #3b4f46 !important;
            }
            .nav-tabs .nav-link {
                color: #6c757d !important;
            }
            
            .custom-switch-large {
                transform: scale(1.5);
                transform-origin: left center;
            }
            .custom-switch-large .form-check-input:checked {
                background-color: #28a745 !important;
                border-color: #28a745 !important;
            }
            .custom-switch-large .form-check-input:not(:checked) {
                background-color: #dc3545 !important;
                border-color: #dc3545 !important;
            }
            .custom-switch-large .form-check-input:focus {
                box-shadow: none !important;
            }
            .custom-switch-large .form-check-input:checked:focus {
                background-color: #28a745 !important;
                border-color: #28a745 !important;
                box-shadow: none !important;
            }
            .custom-switch-large .form-check-input:not(:checked):focus {
                background-color: #dc3545 !important;
                border-color: #dc3545 !important;
                box-shadow: none !important;
            }
            .custom-switch-large .form-check-label {
                font-size: 0.7rem !important;
            }
            #enabled-switch .form-check-label {
                font-size: 0.7rem !important;
            }
            .comments-filter-switch .form-check-input:checked {
                background-color: #28a745 !important;
                border-color: #28a745 !important;
            }
            .comments-filter-switch .form-check-input:not(:checked) {
                background-color: #dc3545 !important;
                border-color: #dc3545 !important;
            }
            .comments-filter-switch .form-check-input:focus {
                box-shadow: none !important;
            }
            .comments-filter-switch .form-check-input:checked:focus {
                background-color: #28a745 !important;
                border-color: #28a745 !important;
                box-shadow: none !important;
            }
            .comments-filter-switch .form-check-input:not(:checked):focus {
                background-color: #dc3545 !important;
                border-color: #dc3545 !important;
                box-shadow: none !important;
            }
            .temporary-free-switch .form-check-input:checked {
                background-color: #28a745 !important;
                border-color: #28a745 !important;
            }
            .temporary-free-switch .form-check-input:not(:checked) {
                background-color: #dc3545 !important;
                border-color: #dc3545 !important;
            }
            .temporary-free-switch .form-check-input:focus {
                box-shadow: none !important;
            }
            .temporary-free-switch .form-check-input:checked:focus {
                background-color: #28a745 !important;
                border-color: #28a745 !important;
                box-shadow: none !important;
            }
            .temporary-free-switch .form-check-input:not(:checked):focus {
                background-color: #dc3545 !important;
                border-color: #dc3545 !important;
                box-shadow: none !important;
            }
            .temporary-free-switch-large {
                transform: scale(1.3);
                transform-origin: left center;
                display: flex;
                align-items: center;
            }
            .temporary-free-switch-large .form-check-input:checked + .form-check-label {
                color: #28a745 !important;
                font-size: 1rem !important;
                margin-left: 0.3rem;
            }
            .temporary-free-switch-large .form-check-input:not(:checked) + .form-check-label {
                color: #dc3545 !important;
                font-size: 1rem !important;
                margin-left: 0.3rem;
            }
            .date-input-group .form-control:focus {
                box-shadow: none !important;
                border-color: #ced4da !important;
                outline: none !important;
                border-width: 1px !important;
            }
            .date-input-group .btn {
                border-right: none !important;
            }
            .date-picker-input:focus {
                box-shadow: none !important;
                outline: none !important;
                border-width: 1px !important;
                border-color: #ced4da !important;
            }
            .date-picker-input {
                border-width: 1px !important;
                cursor: pointer;
            }
            .rich-text-editor {
                font-family: inherit;
                font-size: 0.9rem;
                line-height: 1.5;
            }
            .rich-text-editor:focus {
                border-color: #80bdff !important;
                box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
            }
            .rich-text-editor p {
                margin-bottom: 0.5rem;
            }
            .rich-text-editor ul, .rich-text-editor ol {
                margin-bottom: 0.5rem;
                padding-left: 1.5rem;
            }
            .rich-text-editor a {
                color: #007bff;
                text-decoration: underline;
            }
            .modal .form-control {
                font-size: 0.9rem !important;
            }
            .modal .form-select {
                font-size: 0.9rem !important;
            }
            .modal .form-label {
                font-size: 0.7rem !important;
            }
            .modal textarea.form-control {
                font-size: 0.9rem !important;
            }
            
            /* Comment edit mode styling */
            .academy-comment-card.editing {
                border: 2px solid #007bff;
                box-shadow: 0 0 10px rgba(0, 123, 255, 0.3);
            }
            .academy-comment-card .form-switch {
                margin-bottom: 0;
            }
            .academy-comment-card .form-switch .form-check-input {
                margin-top: 0;
            }
            .academy-comment-card .form-switch .form-check-label {
                font-size: 0.75rem;
                padding-left: 0.5rem;
            }
            
            /* Refresh button styling */
            .refresh-button:hover:not(:disabled) {
                background-color: #567a70 !important;
                border-color: #567a70 !important;
            }
            
            /* Add button styling with ukies green colors */
            .add-button-green {
                background-color: var(--ukies-light-green) !important;
                border-color: var(--ukies-light-green) !important;
                color: white !important;
            }
            .add-button-green:hover:not(:disabled) {
                background-color: var(--ukies-dark-green) !important;
                border-color: var(--ukies-dark-green) !important;
                color: white !important;
            }
            .add-button-green:focus:not(:disabled) {
                background-color: var(--ukies-dark-green) !important;
                border-color: var(--ukies-dark-green) !important;
                color: white !important;
                box-shadow: 0 0 0 0.2rem rgba(59, 79, 70, 0.25) !important;
            }
            .add-button-green:active:not(:disabled) {
                background-color: var(--ukies-dark-green) !important;
                border-color: var(--ukies-dark-green) !important;
                color: white !important;
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    // Handle clicking outside dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showProductDropdown && !event.target.closest('.position-relative')) {
                setShowProductDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showProductDropdown]);

    // Format text functions for rich text editor
    const formatText = (command, value = null) => {
        document.execCommand(command, false, value);
        editorRef.current.focus();
    };

    // Auto-hide alert after 5 seconds
    useEffect(() => {
        if (showAlert) {
            const timer = setTimeout(() => {
                setShowAlert(false);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [showAlert]);

    // Clean up comment listeners on component unmount
    useEffect(() => {
        return () => {
            cleanupCommentListeners();
        };
    }, []);

    // Calculate total series length from modules
    const calculateSeriesLength = (modulesList) => {
        if (!modulesList || modulesList.length === 0) return 0;
        return modulesList.reduce((total, module) => total + (module.length || 0), 0);
    };

    // Set initial content when dialog opens
    useEffect(() => {
        if (editorRef.current && showModal && formData.desciption !== undefined) {
            // Avoid resetting cursor while user is typing
            const isFocused = document.activeElement === editorRef.current;
            if (!isFocused) {
                if (sourceCodeMode) {
                    // In source code mode, set the textarea value
                    editorRef.current.value = formData.desciption || '';
                } else {
                    // In WYSIWYG mode, set the div innerHTML
                    editorRef.current.innerHTML = formData.desciption || '<p>Voer hier de beschrijving in...</p>';
                }
            }
        }
    }, [showModal, formData.desciption, sourceCodeMode]);

    // Set initial content for module editor when module data changes
    useEffect(() => {
        if (moduleEditorRef.current && showModal && moduleFormData.desciption !== undefined) {
            // Avoid resetting cursor while user is typing
            const isFocused = document.activeElement === moduleEditorRef.current;
            if (!isFocused) {
                if (moduleSourceCodeMode) {
                    // In source code mode, set the textarea value
                    moduleEditorRef.current.value = moduleFormData.desciption || '';
                } else {
                    // In WYSIWYG mode, set the div innerHTML
                    moduleEditorRef.current.innerHTML = moduleFormData.desciption || '<p>Voer hier de beschrijving in...</p>';
                }
            }
        }
    }, [showModal, moduleFormData.desciption, moduleSourceCodeMode]);

    // Set initial content for file editor when file data changes
    useEffect(() => {
        if (fileEditorRef.current && showModal && fileFormData.description !== undefined) {
            // Avoid resetting cursor while user is typing
            const isFocused = document.activeElement === fileEditorRef.current;
            if (!isFocused) {
                if (fileSourceCodeMode) {
                    // In source code mode, set the textarea value
                    fileEditorRef.current.value = fileFormData.description || '';
                } else {
                    // In WYSIWYG mode, set the div innerHTML
                    fileEditorRef.current.innerHTML = fileFormData.description || '<p>Voer hier de beschrijving in...</p>';
                }
            }
        }
    }, [showModal, fileFormData.description, fileSourceCodeMode]);

    // Update module number when active module index changes
    useEffect(() => {
        if (moduleFormData.uuid) {
            setModuleFormData(prev => ({
                ...prev,
                module: activeModuleIndex + 1
            }));
        }
    }, [activeModuleIndex]);

    // Handle keyboard shortcuts for module saving
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.ctrlKey && event.key === 's' && showModal && activeTab === 'modules') {
                event.preventDefault();
                handleSaveModule();
            }
        };

        if (showModal && activeTab === 'modules') {
            document.addEventListener('keydown', handleKeyDown);
            return () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [showModal, activeTab, moduleFormData.uuid]);

    // Handle keyboard shortcuts for file saving
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.ctrlKey && event.key === 's' && showModal && activeTab === 'files') {
                event.preventDefault();
                handleSaveFile();
            }
        };

        if (showModal && activeTab === 'files') {
            document.addEventListener('keydown', handleKeyDown);
            return () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [showModal, activeTab, fileFormData.uuid]);

    // Handle keyboard shortcuts for comment saving
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.ctrlKey && event.key === 's' && showModal && activeTab === 'comments' && editingComment !== null) {
                event.preventDefault();
                handleSaveComment();
            }
        };

        if (showModal && activeTab === 'comments' && editingComment !== null) {
            document.addEventListener('keydown', handleKeyDown);
            return () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [showModal, activeTab, editingComment]);



    // Handle asset selection for thumbnail
    const handleThumbnailAssetSelect = (asset) => {
        setFormData(prev => ({
            ...prev,
            thumbnail: asset.image_variations?.large || asset.url
        }));
        setShowThumbnailAssets(false);
    };

    // Handle asset selection for image
    const handleImageAssetSelect = (asset) => {
        const imageUrl = asset.image_variations?.large 
            ? asset.image_variations.large.replace('/large', '/w=3840')
            : asset.url;
        
        setFormData(prev => ({
            ...prev,
            image: imageUrl
        }));
        setShowImageAssets(false);
    };

    // Handle asset selection for module thumbnail
    const handleModuleThumbnailAssetSelect = (asset) => {
        setModuleFormData(prev => ({
            ...prev,
            thumbnail: asset.image_variations?.large || asset.url
        }));
        setShowModuleThumbnailAssets(false);
    };

    // Handle asset selection for file thumbnail
    const handleFileThumbnailAssetSelect = (asset) => {
        setFileFormData(prev => ({
            ...prev,
            thumbnail: asset.image_variations?.large || asset.url
        }));
        setShowFileThumbnailAssets(false);
    };

    // Handle preview image click
    const handlePreviewClick = (imageUrl) => {
        setPreviewImage(imageUrl);
        setShowPreviewModal(true);
    };

    // Handle source code mode toggle
    const handleSourceCodeToggle = () => {
        if (sourceCodeMode) {
            // Switching from source to WYSIWYG
            const sourceContent = editorRef.current.value;
            setFormData(prev => ({ ...prev, desciption: sourceContent }));
        } else {
            // Switching from WYSIWYG to source
            const wysiwygContent = editorRef.current.innerHTML;
            setFormData(prev => ({ ...prev, desciption: wysiwygContent }));
        }
        setSourceCodeMode(!sourceCodeMode);
    };

    // Handle module input changes
    const handleModuleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setModuleFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : (type === 'number' ? parseInt(value) || 0 : value)
        }));
    };

    // Handle module tab change
    const handleModuleTabChange = (moduleIndex) => {
        // Save current module data before switching
        if (modules[activeModuleIndex]) {
            const updatedModules = [...modules];
            updatedModules[activeModuleIndex] = { 
                ...moduleFormData,
                module: activeModuleIndex + 1 // Ensure correct module number
            };
            setModules(updatedModules);
        }
        
        // Switch to new module
        setActiveModuleIndex(moduleIndex);
        if (modules[moduleIndex]) {
            setModuleFormData({
                ...modules[moduleIndex],
                module: moduleIndex + 1 // Set correct module number for new active module
            });
            // Set module tags display value
            const tagsDisplay = modules[moduleIndex].tags ? modules[moduleIndex].tags.map(tag => tag.label || '').join(', ') : '';
            setModuleTagsDisplayValue(tagsDisplay);
        }
    };

    // Handle module description change from contentEditable
    const handleModuleDescriptionChange = (e) => {
        const content = e.target.innerHTML;
        // Don't save placeholder text
        if (content === '<p>Voer hier de beschrijving in...</p>') {
            setModuleFormData(prev => ({ ...prev, desciption: '' }));
        } else {
            setModuleFormData(prev => ({ ...prev, desciption: content }));
        }
    };

    // Handle module editor click to clear placeholder
    const handleModuleEditorClick = () => {
        if (moduleEditorRef.current && moduleEditorRef.current.innerHTML === '<p>Voer hier de beschrijving in...</p>') {
            moduleEditorRef.current.innerHTML = '<p><br></p>';
            // Place cursor at beginning
            const range = document.createRange();
            const selection = window.getSelection();
            range.setStart(moduleEditorRef.current.firstChild, 0);
            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    };

    // Handle module tags change
    const handleModuleTagsChange = (e) => {
        const inputValue = e.target.value;
        setModuleTagsDisplayValue(inputValue);
        
        const tagStrings = inputValue.split(',').map(tag => tag.trim()).filter(tag => tag);
        const tags = tagStrings.map(label => ({ label, color: 'normal' }));
        
        setModuleFormData(prev => ({ ...prev, tags }));
    };

    // Handle module source code mode toggle
    const handleModuleSourceCodeToggle = () => {
        if (moduleSourceCodeMode) {
            // Switching from source to WYSIWYG
            const sourceContent = moduleEditorRef.current.value;
            setModuleFormData(prev => ({ ...prev, desciption: sourceContent }));
        } else {
            // Switching from WYSIWYG to source
            const wysiwygContent = moduleEditorRef.current.innerHTML;
            setModuleFormData(prev => ({ ...prev, desciption: wysiwygContent }));
        }
        setModuleSourceCodeMode(!moduleSourceCodeMode);
    };

    // Format text functions for module rich text editor
    const formatModuleText = (command, value = null) => {
        document.execCommand(command, false, value);
        moduleEditorRef.current.focus();
    };

    // Handle save individual module
    const handleSaveModule = async () => {
        if (!selected || !selected.id || !moduleFormData.uuid) return;
        
        setSavingModule(true);
        try {
            // Ensure module has correct number based on position
            const moduleDataToSave = {
                ...moduleFormData,
                module: activeModuleIndex + 1
            };

            // Save current module data to the modules array
            const updatedModules = [...modules];
            updatedModules[activeModuleIndex] = moduleDataToSave;
            setModules(updatedModules);
            setModuleFormData(moduleDataToSave);

            // Save to Firestore using UUID as document ID
            const moduleDocRef = doc(db, 'series', selected.id, 'modules', moduleFormData.uuid);
            await setDoc(moduleDocRef, moduleDataToSave);

            // Calculate and update series length
            const newSeriesLength = calculateSeriesLength(updatedModules);
            
            // Update series document with new length
            const seriesRef = doc(db, 'series', selected.id);
            await updateDoc(seriesRef, { length: newSeriesLength });

            // Update local series state
            setSeries(prev => prev.map(s => 
                s.id === selected.id 
                    ? { ...s, modules: updatedModules, length: newSeriesLength }
                    : s
            ));

            // Update formData to reflect new length
            setFormData(prev => ({ ...prev, length: newSeriesLength }));

            setShowAlert(true);
            setAlertMessage('Module succesvol opgeslagen!');
            setAlertType('success');
        } catch (error) {
            console.error('Error saving module:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het opslaan van de module. Probeer het opnieuw.');
            setAlertType('danger');
        } finally {
            setSavingModule(false);
        }
    };

    // Handle add new module
    const handleAddModule = async () => {
        const newModule = {
            uuid: uuidv4(),
            name: 'Nieuwe Module',
            shortDesc: '',
            desciption: '',
            length: 0,
            tags: [],
            videoLink: '',
            thumbnail: '',
            series: selected?.name || '',
            module: modules.length + 1
        };
        
        const updatedModules = [...modules, newModule];
        setModules(updatedModules);
        setActiveModuleIndex(updatedModules.length - 1);
        setModuleFormData({
            ...newModule,
            module: updatedModules.length // Set correct module number
        });
        setModuleTagsDisplayValue('');
        
        // Update moduleCount in formData
        setFormData(prev => ({
            ...prev,
            moduleCount: updatedModules.length
        }));
        
        // Update moduleCount in Firebase immediately
        if (selected && selected.id) {
            try {
                const seriesRef = doc(db, 'series', selected.id);
                await updateDoc(seriesRef, {
                    moduleCount: updatedModules.length
                });
            } catch (error) {
                console.error('Error updating moduleCount in Firebase:', error);
            }
        }
    };

    // Handle delete module
    const handleDeleteModule = async (moduleIndex) => {
        if (modules.length <= 1) return; // Don't delete if it's the last module
        
        const moduleToDelete = modules[moduleIndex];
        if (!moduleToDelete || !moduleToDelete.uuid) return;
        
        try {
            // Delete from Firestore
            const moduleDocRef = doc(db, 'series', selected.id, 'modules', moduleToDelete.uuid);
            await deleteDoc(moduleDocRef);
            
            // Update local state
            const updatedModules = modules.filter((_, index) => index !== moduleIndex);
            // Update module numbers based on new order
            const reorderedModules = updatedModules.map((module, index) => ({
                ...module,
                module: index + 1
            }));
            setModules(reorderedModules);
            
            // Update moduleCount in formData immediately
            setFormData(prev => ({
                ...prev,
                moduleCount: reorderedModules.length
            }));
            
            // Calculate new series length and update Firebase
            const newSeriesLength = calculateSeriesLength(reorderedModules);
            const seriesRef = doc(db, 'series', selected.id);
            await updateDoc(seriesRef, {
                moduleCount: reorderedModules.length,
                length: newSeriesLength
            });
            
            // Adjust active module index if necessary
            const newActiveIndex = moduleIndex >= reorderedModules.length ? reorderedModules.length - 1 : moduleIndex;
            setActiveModuleIndex(newActiveIndex);
            
            if (reorderedModules[newActiveIndex]) {
                setModuleFormData(reorderedModules[newActiveIndex]);
                // Set module tags display value for the new active module
                const tagsDisplay = reorderedModules[newActiveIndex].tags ? reorderedModules[newActiveIndex].tags.map(tag => tag.label || '').join(', ') : '';
                setModuleTagsDisplayValue(tagsDisplay);
            } else {
                setModuleFormData({});
                setModuleTagsDisplayValue('');
            }
            
            // Update the main series state
            setSeries(prev => prev.map(s => 
                s.id === selected.id 
                    ? { ...s, modules: reorderedModules, length: newSeriesLength }
                    : s
            ));
            
            // Update formData to reflect new length
            setFormData(prev => ({ ...prev, length: newSeriesLength }));
            
            // Show success message
            setShowAlert(true);
            setAlertMessage('Module succesvol verwijderd!');
            setAlertType('success');
            
        } catch (error) {
            console.error('Error deleting module:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het verwijderen van de module. Probeer het opnieuw.');
            setAlertType('danger');
        }
    };

    // Handle move module left
    const handleMoveModuleLeft = (moduleIndex) => {
        if (moduleIndex <= 0) return; // Can't move first module left
        
        // Save current module data before moving
        const updatedModules = [...modules];
        if (activeModuleIndex === moduleIndex) {
            updatedModules[activeModuleIndex] = { ...moduleFormData };
        }
        
        // Swap modules
        [updatedModules[moduleIndex - 1], updatedModules[moduleIndex]] = 
        [updatedModules[moduleIndex], updatedModules[moduleIndex - 1]];
        
        // Update module numbers based on new positions
        const reorderedModules = updatedModules.map((module, index) => ({
            ...module,
            module: index + 1
        }));
        
        setModules(reorderedModules);
        
        // Update active index if the current module was moved
        if (activeModuleIndex === moduleIndex) {
            setActiveModuleIndex(moduleIndex - 1);
            setModuleFormData(reorderedModules[moduleIndex - 1]);
        } else if (activeModuleIndex === moduleIndex - 1) {
            setActiveModuleIndex(moduleIndex);
            setModuleFormData(reorderedModules[moduleIndex]);
        }
    };

    // Handle move module right
    const handleMoveModuleRight = (moduleIndex) => {
        if (moduleIndex >= modules.length - 1) return; // Can't move last module right
        
        // Save current module data before moving
        const updatedModules = [...modules];
        if (activeModuleIndex === moduleIndex) {
            updatedModules[activeModuleIndex] = { ...moduleFormData };
        }
        
        // Swap modules
        [updatedModules[moduleIndex], updatedModules[moduleIndex + 1]] = 
        [updatedModules[moduleIndex + 1], updatedModules[moduleIndex]];
        
        // Update module numbers based on new positions
        const reorderedModules = updatedModules.map((module, index) => ({
            ...module,
            module: index + 1
        }));
        
        setModules(reorderedModules);
        
        // Update active index if the current module was moved
        if (activeModuleIndex === moduleIndex) {
            setActiveModuleIndex(moduleIndex + 1);
            setModuleFormData(reorderedModules[moduleIndex + 1]);
        } else if (activeModuleIndex === moduleIndex + 1) {
            setActiveModuleIndex(moduleIndex);
            setModuleFormData(reorderedModules[moduleIndex]);
        }
    };

    // File handling functions
    const handleFileInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFileFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : (type === 'number' ? parseInt(value) || 0 : value)
        }));
    };

    const handleFileTabChange = (fileIndex) => {
        // Save current file data before switching
        if (files[activeFileIndex]) {
            const updatedFiles = [...files];
            updatedFiles[activeFileIndex] = { ...fileFormData };
            setFiles(updatedFiles);
        }
        
        // Switch to new file
        setActiveFileIndex(fileIndex);
        if (files[fileIndex]) {
            setFileFormData(files[fileIndex]);
            // Set file tags display value
            const tagsDisplay = files[fileIndex].tags ? files[fileIndex].tags.map(tag => tag.label || '').join(', ') : '';
            setFileTagsDisplayValue(tagsDisplay);
        }
    };

    const handleFileDescriptionChange = (e) => {
        const content = e.target.innerHTML;
        if (content === '<p>Voer hier de beschrijving in...</p>') {
            setFileFormData(prev => ({ ...prev, description: '' }));
        } else {
            setFileFormData(prev => ({ ...prev, description: content }));
        }
    };

    const handleFileEditorClick = () => {
        if (fileEditorRef.current && fileEditorRef.current.innerHTML === '<p>Voer hier de beschrijving in...</p>') {
            fileEditorRef.current.innerHTML = '<p><br></p>';
            const range = document.createRange();
            const selection = window.getSelection();
            range.setStart(fileEditorRef.current.firstChild, 0);
            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    };

    const handleFileTagsChange = (e) => {
        const inputValue = e.target.value;
        setFileTagsDisplayValue(inputValue);
        
        const tagStrings = inputValue.split(',').map(tag => tag.trim()).filter(tag => tag);
        const tags = tagStrings.map(label => ({ label, color: 'normal' }));
        
        setFileFormData(prev => ({ ...prev, tags }));
    };

    const handleFileSourceCodeToggle = () => {
        if (fileSourceCodeMode) {
            const sourceContent = fileEditorRef.current.value;
            setFileFormData(prev => ({ ...prev, description: sourceContent }));
        } else {
            const wysiwygContent = fileEditorRef.current.innerHTML;
            setFileFormData(prev => ({ ...prev, description: wysiwygContent }));
        }
        setFileSourceCodeMode(!fileSourceCodeMode);
    };

    const formatFileText = (command, value = null) => {
        document.execCommand(command, false, value);
        fileEditorRef.current.focus();
    };

    const handleSaveFile = async () => {
        if (!selected || !selected.id || !fileFormData.uuid) return;
        
        setSavingFile(true);
        try {
            const fileDataToSave = { ...fileFormData };

            // Save current file data to the files array
            const updatedFiles = [...files];
            updatedFiles[activeFileIndex] = fileDataToSave;
            setFiles(updatedFiles);
            setFileFormData(fileDataToSave);

            // Save to Firestore using UUID as document ID
            const fileDocRef = doc(db, 'series', selected.id, 'files', fileFormData.uuid);
            await setDoc(fileDocRef, fileDataToSave);

            // Update local series state
            setSeries(prev => prev.map(s => 
                s.id === selected.id 
                    ? { ...s, files: updatedFiles }
                    : s
            ));

            setShowAlert(true);
            setAlertMessage('Bestand succesvol opgeslagen!');
            setAlertType('success');
        } catch (error) {
            console.error('Error saving file:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het opslaan van het bestand. Probeer het opnieuw.');
            setAlertType('danger');
        } finally {
            setSavingFile(false);
        }
    };

    const handleAddFile = async () => {
        const newFile = {
            uuid: uuidv4(),
            name: 'Nieuw Bestand',
            shortDesc: '',
            description: '',
            type: '',
            fileType: '',
            fileLink: '',
            tags: []
        };
        
        const updatedFiles = [...files, newFile];
        setFiles(updatedFiles);
        setActiveFileIndex(updatedFiles.length - 1);
        setFileFormData(newFile);
        setFileTagsDisplayValue('');
        
        // Update fileCount in formData
        setFormData(prev => ({
            ...prev,
            fileCount: updatedFiles.length
        }));
        
        // Update fileCount in Firebase immediately
        if (selected && selected.id) {
            try {
                const seriesRef = doc(db, 'series', selected.id);
                await updateDoc(seriesRef, {
                    fileCount: updatedFiles.length
                });
            } catch (error) {
                console.error('Error updating fileCount in Firebase:', error);
            }
        }
    };

    const handleDeleteFile = async (fileIndex) => {
        if (files.length <= 1) return;
        
        const fileToDelete = files[fileIndex];
        if (!fileToDelete || !fileToDelete.uuid) return;
        
        try {
            // Delete from Firestore
            const fileDocRef = doc(db, 'series', selected.id, 'files', fileToDelete.uuid);
            await deleteDoc(fileDocRef);
            
            // Update local state
            const updatedFiles = files.filter((_, index) => index !== fileIndex);
            setFiles(updatedFiles);
            
            // Update fileCount in formData immediately
            setFormData(prev => ({
                ...prev,
                fileCount: updatedFiles.length
            }));
            
            // Update fileCount in Firebase immediately
            const seriesRef = doc(db, 'series', selected.id);
            await updateDoc(seriesRef, {
                fileCount: updatedFiles.length
            });
            
            // Adjust active file index if necessary
            const newActiveIndex = fileIndex >= updatedFiles.length ? updatedFiles.length - 1 : fileIndex;
            setActiveFileIndex(newActiveIndex);
            
            if (updatedFiles[newActiveIndex]) {
                setFileFormData(updatedFiles[newActiveIndex]);
                const tagsDisplay = updatedFiles[newActiveIndex].tags ? updatedFiles[newActiveIndex].tags.map(tag => tag.label || '').join(', ') : '';
                setFileTagsDisplayValue(tagsDisplay);
            } else {
                setFileFormData({});
                setFileTagsDisplayValue('');
            }
            
            // Update the main series state
            setSeries(prev => prev.map(s => 
                s.id === selected.id 
                    ? { ...s, files: updatedFiles }
                    : s
            ));
            
            setShowAlert(true);
            setAlertMessage('Bestand succesvol verwijderd!');
            setAlertType('success');
            
        } catch (error) {
            console.error('Error deleting file:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het verwijderen van het bestand. Probeer het opnieuw.');
            setAlertType('danger');
        }
    };

    const handleMoveFileLeft = (fileIndex) => {
        if (fileIndex <= 0) return;
        
        const updatedFiles = [...files];
        if (activeFileIndex === fileIndex) {
            updatedFiles[activeFileIndex] = { ...fileFormData };
        }
        
        [updatedFiles[fileIndex - 1], updatedFiles[fileIndex]] = 
        [updatedFiles[fileIndex], updatedFiles[fileIndex - 1]];
        
        setFiles(updatedFiles);
        
        if (activeFileIndex === fileIndex) {
            setActiveFileIndex(fileIndex - 1);
            setFileFormData(updatedFiles[fileIndex - 1]);
        } else if (activeFileIndex === fileIndex - 1) {
            setActiveFileIndex(fileIndex);
            setFileFormData(updatedFiles[fileIndex]);
        }
    };

    const handleMoveFileRight = (fileIndex) => {
        if (fileIndex >= files.length - 1) return;
        
        const updatedFiles = [...files];
        if (activeFileIndex === fileIndex) {
            updatedFiles[activeFileIndex] = { ...fileFormData };
        }
        
        [updatedFiles[fileIndex], updatedFiles[fileIndex + 1]] = 
        [updatedFiles[fileIndex + 1], updatedFiles[fileIndex]];
        
        setFiles(updatedFiles);
        
        if (activeFileIndex === fileIndex) {
            setActiveFileIndex(fileIndex + 1);
            setFileFormData(updatedFiles[fileIndex + 1]);
        } else if (activeFileIndex === fileIndex + 1) {
            setActiveFileIndex(fileIndex);
            setFileFormData(updatedFiles[fileIndex]);
        }
    };

    // Comment handling functions
    const handleCommentClick = (comment, index) => {
        setEditingComment(index);
        setEditCommentData({
            ...comment,
            response: comment.response ? { ...comment.response } : null
        });
    };

    const handleCommentInputChange = (e, field, isResponse = false) => {
        const { value } = e.target;
        if (isResponse) {
            setEditCommentData(prev => ({
                ...prev,
                response: {
                    ...(prev.response || {}),
                    [field]: value
                }
            }));
        } else {
            setEditCommentData(prev => ({
                ...prev,
                [field]: value
            }));
        }
    };

    const handleCommentToggle = (field) => {
        if (field === 'pinned') {
            setEditCommentData(prev => ({
                ...prev,
                pinned: !prev.pinned
            }));
        } else if (field === 'notResponding') {
            setEditCommentData(prev => ({
                ...prev,
                notResponding: !prev.notResponding
            }));
        }
    };

    const handleSaveComment = async () => {
        if (!selected || !selected.id || editingComment === null || !modules[activeCommentModuleIndex]) return;
        
        setSavingComment(true);
        try {
            const currentModule = modules[activeCommentModuleIndex];
            const currentModuleComments = moduleComments[currentModule.uuid] || [];
            
            // Prepare the comment data with response timestamp if response exists
            const commentToSave = { ...editCommentData };
            
            // If there's a response comment and it's new or changed, add/update timestamp
            if (commentToSave.response && commentToSave.response.comment && commentToSave.response.comment.trim()) {
                // Add timestamp if it doesn't exist or if the comment was modified
                if (!commentToSave.response.timestamp) {
                    commentToSave.response.timestamp = new Date().toISOString();
                }
            } else if (commentToSave.response && (!commentToSave.response.comment || !commentToSave.response.comment.trim())) {
                // Remove response if comment is empty
                delete commentToSave.response;
            }

            // Save to module comments subcollection using UUID as document ID
            const commentDocRef = doc(db, 'series', selected.id, 'modules', currentModule.uuid, 'comments', commentToSave.uuid);
            await setDoc(commentDocRef, commentToSave);

            // Update the comment in the local module comments state
            const updatedComments = [...currentModuleComments];
            updatedComments[editingComment] = commentToSave;

            // Update module comments state
            setModuleComments(prev => ({
                ...prev,
                [currentModule.uuid]: updatedComments
            }));

            setEditingComment(null);
            setEditCommentData({});
            
            setShowAlert(true);
            setAlertMessage('Comment succesvol bijgewerkt!');
            setAlertType('success');
        } catch (error) {
            console.error('Error updating comment:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het bijwerken van de comment. Probeer het opnieuw.');
            setAlertType('danger');
        } finally {
            setSavingComment(false);
        }
    };

    const handleDeleteComment = async () => {
        if (!selected || !selected.id || editingComment === null || !modules[activeCommentModuleIndex]) return;
        
        if (!window.confirm('Weet je zeker dat je deze comment wilt verwijderen?')) return;
        
        setSavingComment(true);
        try {
            const currentModule = modules[activeCommentModuleIndex];
            const currentModuleComments = moduleComments[currentModule.uuid] || [];
            const commentToDelete = currentModuleComments[editingComment];
            
            // Delete from module comments subcollection
            const commentDocRef = doc(db, 'series', selected.id, 'modules', currentModule.uuid, 'comments', commentToDelete.uuid);
            await deleteDoc(commentDocRef);

            // Remove the comment from the array
            const updatedComments = currentModuleComments.filter((_, index) => index !== editingComment);

            // Update module comments state
            setModuleComments(prev => ({
                ...prev,
                [currentModule.uuid]: updatedComments
            }));

            setEditingComment(null);
            setEditCommentData({});
            
            setShowAlert(true);
            setAlertMessage('Comment succesvol verwijderd!');
            setAlertType('success');
        } catch (error) {
            console.error('Error deleting comment:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het verwijderen van de comment. Probeer het opnieuw.');
            setAlertType('danger');
        } finally {
            setSavingComment(false);
        }
    };

    const handleUndeleteComment = async (commentIndex) => {
        if (!selected || !selected.id || !modules[activeCommentModuleIndex]) return;
        
        if (!window.confirm('Weet je zeker dat je deze comment wilt herstellen?')) return;
        
        setSavingComment(true);
        try {
            const currentModule = modules[activeCommentModuleIndex];
            const currentModuleComments = moduleComments[currentModule.uuid] || [];
            const commentToUndelete = currentModuleComments[commentIndex];
            
            // Remove deleted flag and related metadata
            const updatedComment = { ...commentToUndelete };
            delete updatedComment.deleted;
            delete updatedComment.deletedAt;
            delete updatedComment.deletedBy;
            
            // Update in Firestore
            const commentDocRef = doc(db, 'series', selected.id, 'modules', currentModule.uuid, 'comments', commentToUndelete.uuid);
            await setDoc(commentDocRef, updatedComment);

            // Update local state
            const updatedComments = [...currentModuleComments];
            updatedComments[commentIndex] = updatedComment;

            setModuleComments(prev => ({
                ...prev,
                [currentModule.uuid]: updatedComments
            }));
            
            setShowAlert(true);
            setAlertMessage('Comment succesvol hersteld!');
            setAlertType('success');
        } catch (error) {
            console.error('Error undeleting comment:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het herstellen van de comment. Probeer het opnieuw.');
            setAlertType('danger');
        } finally {
            setSavingComment(false);
        }
    };

    const handlePermanentDeleteComment = async (commentIndex) => {
        if (!selected || !selected.id || !modules[activeCommentModuleIndex]) return;
        
        if (!window.confirm('Weet je zeker dat je deze comment PERMANENT wilt verwijderen?\n\nDeze actie kan NIET ongedaan worden gemaakt!')) return;
        
        setSavingComment(true);
        try {
            const currentModule = modules[activeCommentModuleIndex];
            const currentModuleComments = moduleComments[currentModule.uuid] || [];
            const commentToDelete = currentModuleComments[commentIndex];
            
            // Permanently delete from Firestore
            const commentDocRef = doc(db, 'series', selected.id, 'modules', currentModule.uuid, 'comments', commentToDelete.uuid);
            await deleteDoc(commentDocRef);

            // Remove from local state
            const updatedComments = currentModuleComments.filter((_, index) => index !== commentIndex);

            setModuleComments(prev => ({
                ...prev,
                [currentModule.uuid]: updatedComments
            }));
            
            setShowAlert(true);
            setAlertMessage('Comment permanent verwijderd!');
            setAlertType('success');
        } catch (error) {
            console.error('Error permanently deleting comment:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het permanent verwijderen van de comment. Probeer het opnieuw.');
            setAlertType('danger');
        } finally {
            setSavingComment(false);
        }
    };

    // Handle refresh data
    const handleRefreshData = async () => {
        setRefreshing(true);
        try {
            // Fetch all data in parallel using collection groups - much more efficient!
            const [seriesSnapshot, modulesSnapshot, filesSnapshot, commentsSnapshot] = await Promise.all([
                getDocs(collection(db, 'series')),
                getDocs(collectionGroup(db, 'modules')),
                getDocs(collectionGroup(db, 'files')),
                getDocs(collectionGroup(db, 'comments'))
            ]);

            // Process series
            const result = [];
            for (const doc of seriesSnapshot.docs) {
                const seriesItem = doc.data();
                seriesItem.id = doc.id; // Add document ID for updates
                seriesItem.modules = []; // Initialize empty arrays
                seriesItem.files = [];
                seriesItem.totalComments = 0;
                seriesItem.unreadComments = 0;
                seriesItem.deletedComments = 0;
                result.push(seriesItem);
            }

            // Create a map for quick series lookup
            const seriesMap = new Map(result.map(series => [series.id, series]));

            // Process modules and add to corresponding series
            modulesSnapshot.docs.forEach(doc => {
                const moduleData = doc.data();
                const seriesId = doc.ref.parent.parent.id; // Get parent series ID
                
                if (seriesMap.has(seriesId)) {
                    seriesMap.get(seriesId).modules.push(moduleData);
                }
            });

            // Process files and add to corresponding series
            filesSnapshot.docs.forEach(doc => {
                const fileData = doc.data();
                const seriesId = doc.ref.parent.parent.id; // Get parent series ID
                
                if (seriesMap.has(seriesId)) {
                    seriesMap.get(seriesId).files.push(fileData);
                }
            });

            // Process comments and calculate counts for each series
            commentsSnapshot.docs.forEach(doc => {
                const commentData = doc.data();
                // Path: series/{seriesId}/modules/{moduleId}/comments/{commentId}
                const seriesId = doc.ref.parent.parent.parent.parent.id;
                
                if (seriesMap.has(seriesId)) {
                    const series = seriesMap.get(seriesId);
                    
                    // Count comments
                    if (!commentData.deleted) {
                        series.totalComments++;
                        if (!(commentData.response || commentData.notResponding)) {
                            series.unreadComments++;
                        }
                    } else {
                        series.deletedComments++;
                    }
                }
            });

            setSeries([...result]);
            
            // Refresh module comments if a series is currently selected
            if (selected) {
                const refreshedSeries = result.find(s => s.id === selected.id);
                if (refreshedSeries) {
                    setupCommentListeners(refreshedSeries);
                }
            }
            
            setShowAlert(true);
            setAlertMessage('Data succesvol ververst!');
            setAlertType('success');
        } catch (error) {
            console.error('Error refreshing data:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het verversen van de data. Probeer het opnieuw.');
            setAlertType('danger');
        } finally {
            setRefreshing(false);
        }
    };

    // Handle delete series
    const handleDeleteSeries = async () => {
        if (!selected || !selected.id) return;
        
        const confirmMessage = `Weet je zeker dat je de HELE SERIE "${selected.name}" wilt verwijderen?\n\nAls je op Ok klikt word de hele serie verwijderd, inclusief alle modules.\n\nDeze actie kan niet ongedaan worden gemaakt!`;
        
        if (!window.confirm(confirmMessage)) return;
        
        setSaving(true);
        try {
            // Delete all comments for each module first
            for (const module of selected.modules || []) {
                const commentsSnapshot = await getDocs(collection(db, 'series', selected.id, 'modules', module.uuid, 'comments'));
                const deleteCommentPromises = commentsSnapshot.docs.map(doc => deleteDoc(doc.ref));
                await Promise.all(deleteCommentPromises);
            }
            
            // Delete all modules
            const modulesSnapshot = await getDocs(collection(db, 'series', selected.id, 'modules'));
            const deleteModulePromises = modulesSnapshot.docs.map(doc => deleteDoc(doc.ref));
            await Promise.all(deleteModulePromises);
            
            // Delete all files
            const filesSnapshot = await getDocs(collection(db, 'series', selected.id, 'files'));
            const deleteFilePromises = filesSnapshot.docs.map(doc => deleteDoc(doc.ref));
            await Promise.all(deleteFilePromises);
            
            // Finally delete the series document
            const seriesRef = doc(db, 'series', selected.id);
            await deleteDoc(seriesRef);

            // Update local state by removing the series
            setSeries(prev => prev.filter(s => s.id !== selected.id));

            setShowModal(false);
            setSelected(null);
            setShowAlert(true);
            setAlertMessage('Serie succesvol verwijderd!');
            setAlertType('success');
        } catch (error) {
            console.error('Error deleting series:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het verwijderen van de serie. Probeer het opnieuw.');
            setAlertType('danger');
        } finally {
            setSaving(false);
        }
    };

    // Handle add new series
    const handleAddNewSeries = async () => {
        try {
            const newSeriesUuid = uuidv4();
            const newSeries = {
                uuid: newSeriesUuid,
                name: 'Nieuwe Serie',
                shortDesc: '',
                desciption: '',
                type: 'Cursus',
                contentType: '',
                availability: 'months',
                availabilityInMonths: 12,
                isFree: false,
                freeRequiresSignup: false,
                isTemporaryFree: false,
                freeUntil: null,
                tags: [],
                length: 0,
                thumbnail: '',
                image: '',
                imagePositionX: 50,
                imagePositionY: 50,
                productId: 0,
                productLink: '',
                alternativeLink: '',
                enabled: false,
                moduleCount: 0,
                fileCount: 0,
                modules: [],
                files: [],
                totalComments: 0,
                unreadComments: 0
            };

            // Add to Firestore
            const seriesRef = doc(db, 'series', newSeriesUuid);
            await setDoc(seriesRef, newSeries);

            // Add ID for local state
            newSeries.id = newSeriesUuid;

            // Update local state
            setSeries(prev => [...prev, newSeries]);

            // Open the modal with the new series
            handleRowClick(newSeries);

            setShowAlert(true);
            setAlertMessage('Nieuwe serie succesvol aangemaakt!');
            setAlertType('success');
        } catch (error) {
            console.error('Error adding new series:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het aanmaken van een nieuwe serie. Probeer het opnieuw.');
            setAlertType('danger');
        }
    };

    // Auth state listener
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                // User is signed in > Refresh token
                // localStorage.setItem('accessToken', user.accessToken)
                setAuthReady(true);
            } else {
                // User is signed out > Remove local storage
                localStorage.removeItem('ukies-webinars-admin')
                localStorage.removeItem('ukies-webinars-accessToken')
                setToken()
                setUser()
                setAuthReady(false);
            }
        })
        
        return () => unsubscribe(); // Cleanup listener
    }, []);

    if(!token) {
        return <Stack><Login user={user} setUser={setUser} token={token} setToken={setToken} /></Stack>
    }

    return (
        <>
            <Navigation user={user} currentPage='series' />
            {showAlert && (
                <Alert 
                    variant={alertType} 
                    dismissible 
                    onClose={() => setShowAlert(false)} 
                    style={{
                        position: 'fixed',
                        top: '15px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 1060,
                        minWidth: '300px',
                        maxWidth: '600px'
                    }}
                >
                    {alertMessage}
                </Alert>
            )}
            
            <Stack style={{marginTop:'50px',padding:'1rem 0'}}>
                <h1 style={{fontSize:'2.5rem'}}>Series</h1>
                <Table striped hover style={{cursor:'pointer'}}>
                    <thead>
                        <tr>
                            <th style={{ textAlign: 'center' }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 4.5C7.5 4.5 3.75 7.5 1.5 12C3.75 16.5 7.5 19.5 12 19.5C16.5 19.5 20.25 16.5 22.5 12C20.25 7.5 16.5 4.5 12 4.5ZM12 17C9.75 17 7.5 15.75 7.5 12C7.5 8.25 9.75 7 12 7C14.25 7 16.5 8.25 16.5 12C16.5 15.75 14.25 17 12 17ZM12 9C10.5 9 9 10.5 9 12C9 13.5 10.5 15 12 15C13.5 15 15 13.5 15 12C15 10.5 13.5 9 12 9Z" fill="currentColor"/>
                                </svg>
                            </th>
                            <th>Naam</th>
                            <th>Type</th>
                            <th>Modules</th>
                            <th>Bestanden</th>
                            <th>Duur</th>
                            <th>Beschikbaarheid</th>
                            <th>Comments</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            series.length > 0 &&
                            series.map((s) => {
                                return(
                                    <tr key={s.uuid} onClick={() => handleRowClick(s)}>
                                        <td style={{ textAlign: 'center', color: s.enabled ? '#28a745' : '#dc3545' }}>
                                            {s.enabled ? '✓' : '✗'}
                                        </td>
                                        <td>{s.name}</td>
                                        <td>{s.type}</td>
                                        <td>{s.moduleCount || 0}</td>
                                        <td>{s.fileCount || 0}</td>
                                        <td>{moment.utc(s.length*1000).format('H') > 0 && moment.utc(s.length*1000).format('H') + 'u'} {moment.utc(s.length*1000).format('m')}m {moment.utc(s.length*1000).format('s')}s</td>
                                        { s.isFree
                                            ? <td>Gratis {s.freeRequiresSignup && 'bij inschrijving'}</td>
                                            : <td>{s.availabilityInMonths} maanden</td>
                                        }
                                        <td>{s.totalComments || 0} reacties / {s.unreadComments || 0} ongelezen</td>
                                    </tr>

                                )
                            })
                        }
                    </tbody>
                </Table>
                
                {/* Action Buttons */}
                <div className="d-flex justify-content-end mt-3 gap-2">
                    <Button 
                        variant="success" 
                        size="sm"
                        onClick={handleAddNewSeries}
                        disabled={refreshing || seriesLoading}
                        title="Klik om een nieuwe serie toe te voegen"
                        className="add-button-green"
                    >
                        + Toevoegen
                    </Button>
                    <Button 
                        variant="primary" 
                        size="sm"
                        onClick={handleRefreshData}
                        disabled={refreshing || seriesLoading}
                        title="Klik om data te verversen"
                        className="refresh-button"
                    >
                        {refreshing ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Verversen...
                            </>
                        ) : (
                            <>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise me-2" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                </svg>
                                Refresh
                            </>
                        )}
                    </Button>
                </div>
                
                {/* Edit Series Modal */}
                <Modal show={showModal} onHide={handleClose} size="xl" backdrop={true} keyboard={true}>
                    <Modal.Header closeButton>
                        <div>
                            <Modal.Title>{selected?.name}</Modal.Title>
                            {selected?.uuid && (
                                <small className="text-muted">{selected.uuid}</small>
                            )}
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                            <Tab eventKey="details" title="Details">
                                <div className="mt-3">
                                    <Form>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Naam</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                value={formData.name || ''}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>

                                        <Row>
                                            <div className="col-md-6">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Type</Form.Label>
                                                    <Form.Select
                                                        name="type"
                                                        value={formData.type || ''}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Selecteer type...</option>
                                                        <option value="Cursus">Cursus</option>
                                                        <option value="Masterclass">Masterclass</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Content Type</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="contentType"
                                                        value={formData.contentType || ''}
                                                        onChange={handleInputChange}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Row>

                                        <Row>
                                            <div className="col-md-6">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Tags (komma gescheiden)</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={tagsDisplayValue}
                                                        onChange={handleTagsChange}
                                                        placeholder="Enter tags separated by commas"
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-6">
                                                                                        <Form.Group className="mb-3">
                                            <Form.Label>Duur (seconden)</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="length"
                                                value={calculateSeriesLength(modules)}
                                                disabled
                                                style={{ backgroundColor: '#f8f9fa' }}
                                            />
                                            <Form.Text className="text-muted">
                                                Wordt automatisch berekend op basis van module lengtes
                                            </Form.Text>
                                        </Form.Group>
                                            </div>
                                        </Row>

                                        <Row>
                                            <div className="col-md-6">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Aantal modules</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="moduleCount"
                                                        value={formData.moduleCount || 0}
                                                        disabled
                                                        style={{ backgroundColor: '#f8f9fa' }}
                                                    />
                                                    <Form.Text className="text-muted">
                                                        Wordt automatisch bijgewerkt bij toevoegen/verwijderen van modules
                                                    </Form.Text>
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Aantal bestanden</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="fileCount"
                                                        value={formData.fileCount || 0}
                                                        disabled
                                                        style={{ backgroundColor: '#f8f9fa' }}
                                                    />
                                                    <Form.Text className="text-muted">
                                                        Wordt automatisch bijgewerkt bij toevoegen/verwijderen van bestanden
                                                    </Form.Text>
                                                </Form.Group>
                                            </div>
                                        </Row>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Korte beschrijving</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                name="shortDesc"
                                                value={formData.shortDesc || ''}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Beschrijving</Form.Label>
                                            
                                            {/* Rich Text Editor Toolbar */}
                                            <div className="border rounded-top p-2 bg-light">
                                                <Button
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    className="me-2"
                                                    onClick={() => formatText('bold')}
                                                    disabled={sourceCodeMode}
                                                >
                                                    <strong>B</strong>
                                                </Button>
                                                <Button
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    className="me-2"
                                                    onClick={() => formatText('italic')}
                                                    disabled={sourceCodeMode}
                                                >
                                                    <em>I</em>
                                                </Button>
                                                <Button
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    className="me-2"
                                                    onClick={() => formatText('underline')}
                                                    disabled={sourceCodeMode}
                                                >
                                                    <u>U</u>
                                                </Button>
                                                <Button
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    className="me-2"
                                                    onClick={() => formatText('insertUnorderedList')}
                                                    disabled={sourceCodeMode}
                                                >
                                                    • List
                                                </Button>
                                                <Button
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    className="me-2"
                                                    onClick={() => formatText('insertOrderedList')}
                                                    disabled={sourceCodeMode}
                                                >
                                                    1. List
                                                </Button>
                                                <Button
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    className="me-2"
                                                    onClick={() => {
                                                        const url = prompt('Enter URL:');
                                                        if (url) formatText('createLink', url);
                                                    }}
                                                    disabled={sourceCodeMode}
                                                >
                                                    🔗 Link
                                                </Button>
                                                <Button
                                                    variant={sourceCodeMode ? "primary" : "outline-secondary"}
                                                    size="sm"
                                                    className="ms-auto"
                                                    onClick={handleSourceCodeToggle}
                                                >
                                                    {sourceCodeMode ? "WYSIWYG" : "</>"}
                                                </Button>
                                            </div>
                                            
                                            {/* Editor Area */}
                                            {sourceCodeMode ? (
                                                <Form.Control
                                                    ref={editorRef}
                                                    as="textarea"
                                                    rows={10}
                                                    value={formData.desciption || ''}
                                                    onChange={(e) => setFormData(prev => ({ ...prev, desciption: e.target.value }))}
                                                    style={{
                                                        fontFamily: 'monospace',
                                                        fontSize: '0.9rem',
                                                        borderTop: 'none',
                                                        borderTopLeftRadius: '0',
                                                        borderTopRightRadius: '0'
                                                    }}
                                                    placeholder="Voer hier de HTML-code in..."
                                                />
                                            ) : (
                                                <div
                                                    ref={editorRef}
                                                    contentEditable="true"
                                                    onInput={handleDescriptionChange}
                                                    onClick={handleEditorClick}
                                                    className="rich-text-editor"
                                                    style={{
                                                        minHeight: '200px',
                                                        maxHeight: '400px',
                                                        overflowY: 'auto',
                                                        border: '1px solid #ced4da',
                                                        borderTop: 'none',
                                                        borderBottomLeftRadius: '0.25rem',
                                                        borderBottomRightRadius: '0.25rem',
                                                        padding: '0.75rem',
                                                        backgroundColor: 'white',
                                                        outline: 'none'
                                                    }}
                                                    suppressContentEditableWarning={true}
                                                />
                                            )}
                                        </Form.Group>

                                        <Row>
                                            <div className="col-md-6">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Thumbnail</Form.Label>
                                                    <Form.Label style={{marginLeft:'2rem'}}>Position</Form.Label>
                                                    {/* Line 1: Thumbnail selection button + Position controls */}
                                                    <div className="d-flex align-items-center gap-2 mb-2">
                                                        <Button 
                                                            variant="outline-secondary" 
                                                            onClick={() => setShowThumbnailAssets(true)}
                                                            className="flex-shrink-0"
                                                            style={{ 
                                                                filter: 'grayscale(100%)',
                                                                minWidth: '35.2px',
                                                                height: '35.2px',
                                                                padding: '0',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                marginRight: '2.6rem'
                                                            }}
                                                        >
                                                            🖼️
                                                        </Button>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <div className="d-flex align-items-center gap-1">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left-right" viewBox="0 0 16 16">
                                                                    <path fillRule="evenodd" d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"/>
                                                                </svg>
                                                                <Form.Control
                                                                    type="number"
                                                                    value={50}
                                                                    min="0"
                                                                    max="100"
                                                                    step="1"
                                                                    placeholder="50"
                                                                    disabled
                                                                    style={{width: '60px'}}
                                                                />
                                                            </div>
                                                            <div className="d-flex align-items-center gap-1">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-down" viewBox="0 0 16 16">
                                                                    <path fillRule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5m-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 1 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5"/>
                                                                </svg>
                                                                <Form.Control
                                                                    type="number"
                                                                    value={50}
                                                                    min="0"
                                                                    max="100"
                                                                    step="1"
                                                                    placeholder="50"
                                                                    disabled
                                                                    style={{width: '60px'}}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* Line 2: Thumbnail URL */}
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.thumbnail || ''}
                                                        disabled
                                                        placeholder="Geen thumbnail geselecteerd"
                                                        className="mb-2 small-font-input"
                                                        style={{backgroundColor: '#f8f9fa'}}
                                                    />
                                                    {/* Line 3: Thumbnail preview */}
                                                    {formData.thumbnail && (
                                                        <div style={{overflow:'hidden',width:'270px',aspectRatio:'3/2',display:'flex',alignItems:'start',justifyContent:'center'}}>
                                                            <img 
                                                                src={formData.thumbnail} 
                                                                alt="Thumbnail preview" 
                                                                style={{ 
                                                                    width: '100%', 
                                                                    cursor: 'pointer',
                                                                    border: '1px solid #dee2e6',
                                                                    borderRadius: '4px'
                                                                }}
                                                                onClick={() => handlePreviewClick(formData.thumbnail)}
                                                            />
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Header</Form.Label>
                                                    <Form.Label style={{marginLeft:'3rem'}}>Position</Form.Label>
                                                    {/* Line 1: Image selection button + Position controls */}
                                                    <div className="d-flex align-items-center gap-2 mb-2">
                                                        <Button 
                                                            variant="outline-secondary" 
                                                            onClick={() => setShowImageAssets(true)}
                                                            className="flex-shrink-0"
                                                            style={{ 
                                                                filter: 'grayscale(100%)',
                                                                minWidth: '35.2px',
                                                                height: '35.2px',
                                                                padding: '0',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                marginRight: '2.6rem'
                                                            }}
                                                        >
                                                            🖼️
                                                        </Button>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <div className="d-flex align-items-center gap-1">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left-right" viewBox="0 0 16 16">
                                                                    <path fillRule="evenodd" d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"/>
                                                                </svg>
                                                                <Form.Control
                                                                    type="number"
                                                                    name="imagePositionX"
                                                                    value={formData.imagePositionX || 50}
                                                                    onChange={handleInputChange}
                                                                    min="0"
                                                                    max="100"
                                                                    step="1"
                                                                    placeholder="50"
                                                                    disabled
                                                                    style={{width: '60px'}}
                                                                />
                                                            </div>
                                                            <div className="d-flex align-items-center gap-1">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-down" viewBox="0 0 16 16">
                                                                    <path fillRule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5m-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 1 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5"/>
                                                                </svg>
                                                                <Form.Control
                                                                    type="number"
                                                                    name="imagePositionY"
                                                                    value={formData.imagePositionY || 50}
                                                                    onChange={handleInputChange}
                                                                    min="0"
                                                                    max="100"
                                                                    step="1"
                                                                    placeholder="50"
                                                                    style={{width: '60px'}}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* Line 2: Image URL */}
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.image || ''}
                                                        disabled
                                                        placeholder="Geen image geselecteerd"
                                                        className="mb-2 small-font-input"
                                                        style={{backgroundColor: '#f8f9fa'}}
                                                    />
                                                    {/* Line 3: Image preview */}
                                                    {formData.image && (
                                                        <div style={{overflow:'hidden',width:'100%',aspectRatio:'3/1',display:'flex',alignItems:'center',justifyContent:'center'}}>
                                                            <img 
                                                                src={formData.image} 
                                                                alt="Image preview" 
                                                                style={{ 
                                                                    width: '100%', 
                                                                    transform: `translate(${50 - (formData.imagePositionX || 50)}%, ${50 - (formData.imagePositionY || 50)}%)`,
                                                                    cursor: 'pointer',
                                                                    border: '1px solid #dee2e6',
                                                                    borderRadius: '4px'
                                                                }}
                                                                onClick={() => handlePreviewClick(formData.image)}
                                                            />
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            </div>
                                        </Row>



                                        <hr />

                                        <Form.Group className="mb-3">
                                            <Form.Label>Product</Form.Label>
                                            <div className="position-relative">
                                                <Form.Control
                                                    type="text"
                                                    value={productSearchTerm}
                                                    onChange={handleProductSearch}
                                                    onFocus={() => setShowProductDropdown(true)}
                                                    placeholder="Type om te zoeken of selecteer een product..."
                                                />
                                                {showProductDropdown && filteredProducts.length > 0 && (
                                                    <div className="position-absolute w-100 bg-white border rounded shadow-sm mt-1" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                                                        {filteredProducts.slice(0, 10).map((product) => (
                                                            <div
                                                                key={product.id}
                                                                className="p-2 cursor-pointer border-bottom"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => handleProductSelect(product)}
                                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                                                onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                                            >
                                                                <div className="fw-bold">{product.title}</div>
                                                                <small className="text-muted">ID: {product.id}</small>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                            {formData.productId && (
                                                <Form.Text className="text-muted">
                                                    Geselecteerd Product ID: {formData.productId}
                                                </Form.Text>
                                            )}
                                        </Form.Group>

                                        <Row>
                                            <div className="col-md-6">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Product Link</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="productLink"
                                                        value={formData.productLink || ''}
                                                        onChange={handleInputChange}
                                                        disabled
                                                    />
                                                </Form.Group>
                                            </div>
                                            
                                            <div className="col-md-6">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Alternatieve link</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="alternativeLink"
                                                        value={formData.alternativeLink || ''}
                                                        onChange={handleInputChange}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Row>

                                        <hr />

                                        <Row>
                                            <div className="col-md-6">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Beschikbaarheid</Form.Label>
                                                    <Form.Select
                                                        value={formData.availability || 'months'}
                                                        onChange={handleAvailabilityTypeChange}
                                                    >
                                                        <option value="months">Beschikbaarheid (maanden)</option>
                                                        <option value="free">Gratis</option>
                                                        <option value="free-signup">Gratis na inschrijving</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </div>
                                            {formData.availability === 'months' && (
                                                <div className="col-md-6">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Aantal maanden</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            name="availabilityInMonths"
                                                            value={formData.availabilityInMonths || 0}
                                                            onChange={handleInputChange}
                                                        />
                                                    </Form.Group>
                                                </div>
                                            )}
                                        </Row>
                                        
                                                                                {/* Temporary Free Options - only show when availability is months */}
                                        {formData.availability === 'months' && (
                                            <>
                                                {/* Line 1: Temporary Free Switch */}
                                                <Row className="mt-3">
                                                    <div className="col-md-6">
                                                        <Form.Group className="mb-3" style={{marginTop: '-0.5rem'}}>
                                                            <Form.Switch
                                                                id="temporary-free-switch"
                                                                label="Tijdelijk gratis"
                                                                checked={isTemporaryFree}
                                                                onChange={handleTemporaryFreeToggle}
                                                                className="temporary-free-switch temporary-free-switch-large"
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </Row>
                                                
                                                {/* Line 2: Date picker with signup switch when temporary free is checked */}
                                                {isTemporaryFree && (
                                                    <Row>
                                                        <div className="col-md-6">
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Gratis tot <span style={{color: '#dc3545'}}>*</span></Form.Label>
                                                                <div className="d-flex align-items-center" style={{gap: '1rem', justifyContent: 'flex-start'}}>
                                                                    <div className="input-group date-input-group" style={{flex: '0 0 auto', width: '200px'}}>
                                                                        <button 
                                                                            type="button"
                                                                            className="btn btn-outline-secondary"
                                                                            onClick={() => datePickerRef.current?.setOpen(true)}
                                                                            title="Open kalender"
                                                                            style={{
                                                                                padding: '0.2rem', 
                                                                                height: '35.2px',
                                                                                minWidth: '35.2px',
                                                                                boxShadow: 'none',
                                                                                border: '1px solid #ced4da',
                                                                                borderTopRightRadius: '0',
                                                                                borderBottomRightRadius: '0',
                                                                                borderRight: 'none'
                                                                            }}
                                                                        >
                                                                            <svg viewBox="0 0 24 24" fill="none" style={{width:'100%', height: '100%'}}>
                                                                                <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" fill="currentColor"/>
                                                                            </svg>
                                                                        </button>
                                                                        <DatePicker
                                                                            ref={datePickerRef}
                                                                            selected={formData.freeUntil}
                                                                            onChange={handleFreeUntilDateChange}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            className="form-control"
                                                                            placeholderText="Selecteer einddatum"
                                                                            minDate={new Date()}
                                                                            customInput={
                                                                                <input 
                                                                                    className="form-control react-datepicker-ignore-onclickoutside date-picker-input" 
                                                                                    style={{
                                                                                        borderTopLeftRadius: '0',
                                                                                        borderBottomLeftRadius: '0',
                                                                                        boxShadow: 'none !important',
                                                                                        outline: 'none !important',
                                                                                        borderWidth: '1px !important',
                                                                                        width: '160px'
                                                                                    }}
                                                                                    required={isTemporaryFree}
                                                                                />
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <Form.Switch
                                                                        id="temporary-free-signup-switch"
                                                                        label="Inschrijving vereist"
                                                                        checked={formData.freeRequiresSignup || false}
                                                                        onChange={handleTemporaryFreeSignupToggle}
                                                                        className="temporary-free-switch"
                                                                        style={{
                                                                            whiteSpace: 'nowrap',
                                                                            fontSize: '0.875rem',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '0.5rem'
                                                                        }}
                                                                    />
                                                                </div>
                                                            </Form.Group>
                                                        </div>
                                                    </Row>
                                                )}
                                            </>
                                        )}
                                    </Form>
                                </div>
                            </Tab>
                            
                            <Tab eventKey="modules" title={`Modules (${modules.length || 0})`}>
                                <div className="mt-3">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h6>Module bewerken</h6>
                                        <div>
                                            <Button 
                                                variant="success" 
                                                size="sm" 
                                                onClick={handleAddModule}
                                                className="add-button-green"
                                            >
                                                + Toevoegen
                                            </Button>
                                        </div>
                                    </div>

                                    {modules.length > 0 ? (
                                        <>
                                                                        {/* Module Tabs */}
                            <div className="mb-3">
                                <div className="d-flex flex-wrap gap-2">
                                    {modules.map((module, index) => (
                                        <Button
                                            key={module.uuid || index}
                                            variant={activeModuleIndex === index ? "primary" : "outline-primary"}
                                            size="sm"
                                            onClick={() => handleModuleTabChange(index)}
                                            style={{ minWidth: '120px' }}
                                        >
                                            {index + 1}. {module.name || `Module ${index + 1}`}
                                        </Button>
                                    ))}
                                </div>
                            </div>

                                                                        {/* Module Edit Form */}
                            <Card>
                                <Card.Body>
                                    <Form>
                                        {/* Module Reorder Buttons */}
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div className="d-flex">
                                                <Button
                                                    variant="outline-secondary"
                                                    onClick={() => handleMoveModuleLeft(activeModuleIndex)}
                                                    disabled={activeModuleIndex === 0}
                                                    style={{ 
                                                        width: '35.2px',
                                                        height: '35.2px',
                                                        padding: '0',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        borderTopRightRadius: '0',
                                                        borderBottomRightRadius: '0'
                                                    }}
                                                >
                                                    🠄
                                                </Button>
                                                <Button
                                                    variant="outline-secondary"
                                                    onClick={() => handleMoveModuleRight(activeModuleIndex)}
                                                    disabled={activeModuleIndex === modules.length - 1}
                                                    style={{ 
                                                        width: '35.2px',
                                                        height: '35.2px',
                                                        padding: '0',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        borderTopLeftRadius: '0',
                                                        borderBottomLeftRadius: '0',
                                                        borderLeft: '0'
                                                    }}
                                                    dangerouslySetInnerHTML={{ __html: '&#129030;' }}
                                                >
                                                </Button>
                                            </div>
                                            <div className="text-muted small">
                                                Module {activeModuleIndex + 1} van {modules.length}
                                            </div>
                                        </div>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Module Naam</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                value={moduleFormData.name || ''}
                                                onChange={handleModuleInputChange}
                                            />
                                        </Form.Group>



                                        <Form.Group className="mb-3">
                                            <Form.Label>Thumbnail</Form.Label>
                                            <Form.Label style={{marginLeft:'2rem'}}>Position</Form.Label>
                                            {/* Line 1: Thumbnail selection button + Position controls */}
                                            <div className="d-flex align-items-center gap-2 mb-2">
                                                <Button 
                                                    variant="outline-secondary" 
                                                    onClick={() => setShowModuleThumbnailAssets(true)}
                                                    className="flex-shrink-0"
                                                    style={{ 
                                                        filter: 'grayscale(100%)',
                                                        minWidth: '35.2px',
                                                        height: '35.2px',
                                                        padding: '0',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        marginRight: '1rem'
                                                    }}
                                                >
                                                    🖼️
                                                </Button>
                                                <div className="d-flex align-items-center gap-2">
                                                    <div className="d-flex align-items-center gap-1">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left-right" viewBox="0 0 16 16">
                                                            <path fillRule="evenodd" d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"/>
                                                        </svg>
                                                        <Form.Control
                                                            type="number"
                                                            value={50}
                                                            min="0"
                                                            max="100"
                                                            step="1"
                                                            placeholder="50"
                                                            disabled
                                                            style={{width: '60px'}}
                                                        />
                                                    </div>
                                                    <div className="d-flex align-items-center gap-1">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-down" viewBox="0 0 16 16">
                                                            <path fillRule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5m-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 1 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5"/>
                                                        </svg>
                                                        <Form.Control
                                                            type="number"
                                                            value={50}
                                                            min="0"
                                                            max="100"
                                                            step="1"
                                                            placeholder="50"
                                                            disabled
                                                            style={{width: '60px'}}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Line 2: Thumbnail URL */}
                                            <Form.Control
                                                type="text"
                                                value={moduleFormData.thumbnail || ''}
                                                disabled
                                                placeholder="Geen thumbnail geselecteerd"
                                                className="mb-2 small-font-input"
                                                style={{backgroundColor: '#f8f9fa'}}
                                            />
                                            {/* Line 3: Thumbnail preview */}
                                            {moduleFormData.thumbnail && (
                                                <div style={{overflow:'hidden',width:'270px',aspectRatio:'3/2'}}>
                                                    <img 
                                                        src={moduleFormData.thumbnail} 
                                                        alt="Module thumbnail preview" 
                                                        style={{ 
                                                            width: '100%', 
                                                            cursor: 'pointer',
                                                            border: '1px solid #dee2e6',
                                                            borderRadius: '4px'
                                                        }}
                                                        onClick={() => handlePreviewClick(moduleFormData.thumbnail)}
                                                    />
                                                </div>
                                            )}
                                        </Form.Group>

                                                                                                <Form.Group className="mb-3">
                                            <Form.Label>Tags (komma gescheiden)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={moduleTagsDisplayValue}
                                                onChange={handleModuleTagsChange}
                                                placeholder="Enter tags separated by commas"
                                            />
                                        </Form.Group>

                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Korte Beschrijving</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                rows={2}
                                                                name="shortDesc"
                                                                value={moduleFormData.shortDesc || ''}
                                                                onChange={handleModuleInputChange}
                                                            />
                                                        </Form.Group>

                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Beschrijving</Form.Label>
                                                            
                                                            {/* Rich Text Editor Toolbar */}
                                                            <div className="border rounded-top p-2 bg-light">
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    size="sm"
                                                                    className="me-2"
                                                                    onClick={() => formatModuleText('bold')}
                                                                    disabled={moduleSourceCodeMode}
                                                                >
                                                                    <strong>B</strong>
                                                                </Button>
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    size="sm"
                                                                    className="me-2"
                                                                    onClick={() => formatModuleText('italic')}
                                                                    disabled={moduleSourceCodeMode}
                                                                >
                                                                    <em>I</em>
                                                                </Button>
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    size="sm"
                                                                    className="me-2"
                                                                    onClick={() => formatModuleText('underline')}
                                                                    disabled={moduleSourceCodeMode}
                                                                >
                                                                    <u>U</u>
                                                                </Button>
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    size="sm"
                                                                    className="me-2"
                                                                    onClick={() => formatModuleText('insertUnorderedList')}
                                                                    disabled={moduleSourceCodeMode}
                                                                >
                                                                    • List
                                                                </Button>
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    size="sm"
                                                                    className="me-2"
                                                                    onClick={() => formatModuleText('insertOrderedList')}
                                                                    disabled={moduleSourceCodeMode}
                                                                >
                                                                    1. List
                                                                </Button>
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    size="sm"
                                                                    className="me-2"
                                                                    onClick={() => {
                                                                        const url = prompt('Enter URL:');
                                                                        if (url) formatModuleText('createLink', url);
                                                                    }}
                                                                    disabled={moduleSourceCodeMode}
                                                                >
                                                                    🔗 Link
                                                                </Button>
                                                                <Button
                                                                    variant={moduleSourceCodeMode ? "primary" : "outline-secondary"}
                                                                    size="sm"
                                                                    className="ms-auto"
                                                                    onClick={handleModuleSourceCodeToggle}
                                                                >
                                                                    {moduleSourceCodeMode ? "WYSIWYG" : "</>"}
                                                                </Button>
                                                            </div>
                                                            
                                                            {/* Editor Area */}
                                                            {moduleSourceCodeMode ? (
                                                                <Form.Control
                                                                    ref={moduleEditorRef}
                                                                    as="textarea"
                                                                    rows={10}
                                                                    value={moduleFormData.desciption || ''}
                                                                    onChange={(e) => setModuleFormData(prev => ({ ...prev, desciption: e.target.value }))}
                                                                    style={{
                                                                        fontFamily: 'monospace',
                                                                        fontSize: '0.9rem',
                                                                        borderTop: 'none',
                                                                        borderTopLeftRadius: '0',
                                                                        borderTopRightRadius: '0'
                                                                    }}
                                                                    placeholder="Voer hier de HTML-code in..."
                                                                />
                                                            ) : (
                                                                <div
                                                                    ref={moduleEditorRef}
                                                                    contentEditable="true"
                                                                    onInput={handleModuleDescriptionChange}
                                                                    onClick={handleModuleEditorClick}
                                                                    className="rich-text-editor"
                                                                    style={{
                                                                        minHeight: '200px',
                                                                        maxHeight: '400px',
                                                                        overflowY: 'auto',
                                                                        border: '1px solid #ced4da',
                                                                        borderTop: 'none',
                                                                        borderBottomLeftRadius: '0.25rem',
                                                                        borderBottomRightRadius: '0.25rem',
                                                                        padding: '0.75rem',
                                                                        backgroundColor: 'white',
                                                                        outline: 'none'
                                                                    }}
                                                                    suppressContentEditableWarning={true}
                                                                />
                                                            )}
                                                        </Form.Group>

                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Video Link</Form.Label>
                                                            <Form.Select
                                                                name="videoLink"
                                                                value={moduleFormData.videoLink || ''}
                                                                onChange={handleModuleInputChange}
                                                                onFocus={fetchVideoFolders}
                                                                disabled={videoFoldersLoading}
                                                            >
                                                                <option value="">Selecteer een video...</option>
                                                                {videoFolders.map((folder) => (
                                                                    <option key={folder.name} value={folder.path}>
                                                                        {folder.name.replace(/-/g, ' ').replace('module','- module').charAt(0).toUpperCase() + folder.name.replace(/-/g, ' ').replace('module','- Module').slice(1)}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                            {videoFoldersLoading && (
                                                                <Form.Text className="text-muted">
                                                                    Video folders laden...
                                                                </Form.Text>
                                                            )}
                                                            {moduleFormData.videoLink && (
                                                                <Form.Text className="text-muted">
                                                                    Geselecteerd: {moduleFormData.videoLink}
                                                                </Form.Text>
                                                            )}
                                                        </Form.Group>

                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Duur (seconden)</Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                name="length"
                                                                value={moduleFormData.length || 0}
                                                                onChange={handleModuleInputChange}
                                                                style={{ maxWidth: '200px' }}
                                                            />
                                                        </Form.Group>

                                                        <div className="text-muted small">
                                                            <strong>UUID:</strong> {moduleFormData.uuid}
                                                        </div>

                                                        <hr />

                                                        <div className="d-flex justify-content-end gap-2">
                                                            {modules.length > 1 && (
                                                                <Button 
                                                                    variant="danger" 
                                                                    onClick={() => {
                                                                        if (window.confirm('Weet je zeker dat je deze module wilt verwijderen?')) {
                                                                            handleDeleteModule(activeModuleIndex);
                                                                        }
                                                                    }}
                                                                >
                                                                    Verwijderen
                                                                </Button>
                                                            )}
                                                            <Button 
                                                                variant="primary" 
                                                                onClick={handleSaveModule}
                                                                disabled={savingModule || !moduleFormData.uuid}
                                                            >
                                                                {savingModule ? 'Opslaan...' : 'Opslaan'}
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                </Card.Body>
                                            </Card>
                                        </>
                                    ) : (
                                        <div className="text-center p-4">
                                            <p>Geen modules gevonden.</p>
                                            <Button variant="primary" onClick={handleAddModule}>
                                                Eerste Module Toevoegen
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            </Tab>
                            
                            <Tab eventKey="files" title={`Files (${files.length || 0})`}>
                                <div className="mt-3">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h6>Bestand bewerken</h6>
                                        <div>
                                            <Button 
                                                variant="success" 
                                                size="sm" 
                                                onClick={handleAddFile}
                                                className="add-button-green"
                                            >
                                                + Toevoegen
                                            </Button>
                                        </div>
                                    </div>

                                    {files.length > 0 ? (
                                        <>
                                            {/* File Tabs */}
                                            <div className="mb-3">
                                                <div className="d-flex flex-wrap gap-2">
                                                    {files.map((file, index) => (
                                                        <Button
                                                            key={file.uuid || index}
                                                            variant={activeFileIndex === index ? "primary" : "outline-primary"}
                                                            size="sm"
                                                            onClick={() => handleFileTabChange(index)}
                                                            style={{ minWidth: '120px' }}
                                                        >
                                                            {index + 1}. {file.name || `Bestand ${index + 1}`}
                                                        </Button>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* File Edit Form */}
                                            <Card>
                                                <Card.Body>
                                                    <Form>
                                                        {/* File Reorder Buttons */}
                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                            <div className="d-flex">
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    onClick={() => handleMoveFileLeft(activeFileIndex)}
                                                                    disabled={activeFileIndex === 0}
                                                                    style={{ 
                                                                        width: '35.2px',
                                                                        height: '35.2px',
                                                                        padding: '0',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        borderTopRightRadius: '0',
                                                                        borderBottomRightRadius: '0'
                                                                    }}
                                                                >
                                                                    🠄
                                                                </Button>
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    onClick={() => handleMoveFileRight(activeFileIndex)}
                                                                    disabled={activeFileIndex === files.length - 1}
                                                                    style={{ 
                                                                        width: '35.2px',
                                                                        height: '35.2px',
                                                                        padding: '0',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        borderTopLeftRadius: '0',
                                                                        borderBottomLeftRadius: '0',
                                                                        borderLeft: '0'
                                                                    }}
                                                                    dangerouslySetInnerHTML={{ __html: '&#129030;' }}
                                                                >
                                                                </Button>
                                                            </div>
                                                            <div className="text-muted small">
                                                                Bestand {activeFileIndex + 1} van {files.length}
                                                            </div>
                                                        </div>

                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Bestandsnaam</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="name"
                                                                value={fileFormData.name || ''}
                                                                onChange={handleFileInputChange}
                                                            />
                                                        </Form.Group>

                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Thumbnail</Form.Label>
                                                            <Form.Label style={{marginLeft:'2rem'}}>Position</Form.Label>
                                                            {/* Line 1: Thumbnail selection button + Position controls */}
                                                            <div className="d-flex align-items-center gap-2 mb-2">
                                                                <Button 
                                                                    variant="outline-secondary" 
                                                                    onClick={() => setShowFileThumbnailAssets(true)}
                                                                    className="flex-shrink-0"
                                                                    style={{ 
                                                                        filter: 'grayscale(100%)',
                                                                        minWidth: '35.2px',
                                                                        height: '35.2px',
                                                                        padding: '0',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        marginRight: '1rem'
                                                                    }}
                                                                >
                                                                    🖼️
                                                                </Button>
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <div className="d-flex align-items-center gap-1">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left-right" viewBox="0 0 16 16">
                                                                            <path fillRule="evenodd" d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"/>
                                                                        </svg>
                                                                        <Form.Control
                                                                            type="number"
                                                                            value={50}
                                                                            min="0"
                                                                            max="100"
                                                                            step="1"
                                                                            placeholder="50"
                                                                            disabled
                                                                            style={{width: '60px'}}
                                                                        />
                                                                    </div>
                                                                    <div className="d-flex align-items-center gap-1">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-down" viewBox="0 0 16 16">
                                                                            <path fillRule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5m-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 1 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5"/>
                                                                        </svg>
                                                                        <Form.Control
                                                                            type="number"
                                                                            value={50}
                                                                            min="0"
                                                                            max="100"
                                                                            step="1"
                                                                            placeholder="50"
                                                                            disabled
                                                                            style={{width: '60px'}}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* Line 2: Thumbnail URL */}
                                                            <Form.Control
                                                                type="text"
                                                                value={fileFormData.thumbnail || ''}
                                                                disabled
                                                                placeholder="Geen thumbnail geselecteerd"
                                                                className="mb-2 small-font-input"
                                                                style={{backgroundColor: '#f8f9fa'}}
                                                            />
                                                            {/* Line 3: Thumbnail preview */}
                                                            {fileFormData.thumbnail && (
                                                                <div style={{overflow:'hidden',width:'270px',aspectRatio:'3/2'}}>
                                                                    <img 
                                                                        src={fileFormData.thumbnail} 
                                                                        alt="File thumbnail preview" 
                                                                        style={{ 
                                                                            width: '100%', 
                                                                            cursor: 'pointer',
                                                                            border: '1px solid #dee2e6',
                                                                            borderRadius: '4px'
                                                                        }}
                                                                        onClick={() => handlePreviewClick(fileFormData.thumbnail)}
                                                                    />
                                                                </div>
                                                            )}
                                                        </Form.Group>

                                                        <Row>
                                                            <div className="col-md-6">
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Type</Form.Label>
                                                                    <Form.Select
                                                                        name="type"
                                                                        value={fileFormData.type || ''}
                                                                        onChange={handleFileInputChange}
                                                                    >
                                                                        <option value="">Selecteer type...</option>
                                                                        <option value="E-book">E-book</option>
                                                                        <option value="Kalender">Kalender</option>
                                                                        <option value="Kortingscode">Kortingscode</option>
                                                                        <option value="Ticket">Ticket</option>
                                                                        <option value="Presentatie">Presentatie</option>
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Bestandstype</Form.Label>
                                                                    <Form.Select
                                                                        name="fileType"
                                                                        value={fileFormData.fileType || ''}
                                                                        onChange={handleFileInputChange}
                                                                    >
                                                                        <option value="">Selecteer bestandstype...</option>
                                                                        <option value="PDF">PDF</option>
                                                                        <option value="Word document">Word document</option>
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </div>
                                                        </Row>

                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Tags (komma gescheiden)</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={fileTagsDisplayValue}
                                                                onChange={handleFileTagsChange}
                                                                placeholder="Enter tags separated by commas"
                                                            />
                                                        </Form.Group>

                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Korte Beschrijving</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                rows={2}
                                                                name="shortDesc"
                                                                value={fileFormData.shortDesc || ''}
                                                                onChange={handleFileInputChange}
                                                            />
                                                        </Form.Group>

                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Beschrijving</Form.Label>
                                                            
                                                            {/* Rich Text Editor Toolbar */}
                                                            <div className="border rounded-top p-2 bg-light">
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    size="sm"
                                                                    className="me-2"
                                                                    onClick={() => formatFileText('bold')}
                                                                    disabled={fileSourceCodeMode}
                                                                >
                                                                    <strong>B</strong>
                                                                </Button>
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    size="sm"
                                                                    className="me-2"
                                                                    onClick={() => formatFileText('italic')}
                                                                    disabled={fileSourceCodeMode}
                                                                >
                                                                    <em>I</em>
                                                                </Button>
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    size="sm"
                                                                    className="me-2"
                                                                    onClick={() => formatFileText('underline')}
                                                                    disabled={fileSourceCodeMode}
                                                                >
                                                                    <u>U</u>
                                                                </Button>
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    size="sm"
                                                                    className="me-2"
                                                                    onClick={() => formatFileText('insertUnorderedList')}
                                                                    disabled={fileSourceCodeMode}
                                                                >
                                                                    • List
                                                                </Button>
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    size="sm"
                                                                    className="me-2"
                                                                    onClick={() => formatFileText('insertOrderedList')}
                                                                    disabled={fileSourceCodeMode}
                                                                >
                                                                    1. List
                                                                </Button>
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    size="sm"
                                                                    className="me-2"
                                                                    onClick={() => {
                                                                        const url = prompt('Enter URL:');
                                                                        if (url) formatFileText('createLink', url);
                                                                    }}
                                                                    disabled={fileSourceCodeMode}
                                                                >
                                                                    🔗 Link
                                                                </Button>
                                                                <Button
                                                                    variant={fileSourceCodeMode ? "primary" : "outline-secondary"}
                                                                    size="sm"
                                                                    className="ms-auto"
                                                                    onClick={handleFileSourceCodeToggle}
                                                                >
                                                                    {fileSourceCodeMode ? "WYSIWYG" : "</>"}
                                                                </Button>
                                                            </div>
                                                            
                                                            {/* Editor Area */}
                                                            {fileSourceCodeMode ? (
                                                                <Form.Control
                                                                    ref={fileEditorRef}
                                                                    as="textarea"
                                                                    rows={10}
                                                                    value={fileFormData.description || ''}
                                                                    onChange={(e) => setFileFormData(prev => ({ ...prev, description: e.target.value }))}
                                                                    style={{
                                                                        fontFamily: 'monospace',
                                                                        fontSize: '0.9rem',
                                                                        borderTop: 'none',
                                                                        borderTopLeftRadius: '0',
                                                                        borderTopRightRadius: '0'
                                                                    }}
                                                                    placeholder="Voer hier de HTML-code in..."
                                                                />
                                                            ) : (
                                                                <div
                                                                    ref={fileEditorRef}
                                                                    contentEditable="true"
                                                                    onInput={handleFileDescriptionChange}
                                                                    onClick={handleFileEditorClick}
                                                                    className="rich-text-editor"
                                                                    style={{
                                                                        minHeight: '200px',
                                                                        maxHeight: '400px',
                                                                        overflowY: 'auto',
                                                                        border: '1px solid #ced4da',
                                                                        borderTop: 'none',
                                                                        borderBottomLeftRadius: '0.25rem',
                                                                        borderBottomRightRadius: '0.25rem',
                                                                        padding: '0.75rem',
                                                                        backgroundColor: 'white',
                                                                        outline: 'none'
                                                                    }}
                                                                    suppressContentEditableWarning={true}
                                                                />
                                                            )}
                                                        </Form.Group>

                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Bestandslink</Form.Label>
                                                            <Form.Select
                                                                name="fileLink"
                                                                value={fileFormData.fileLink || ''}
                                                                onChange={handleFileInputChange}
                                                                onFocus={fetchStorageFiles}
                                                                disabled={storageFilesLoading}
                                                            >
                                                                <option value="">Selecteer een bestand...</option>
                                                                {storageFiles.map((file) => (
                                                                    <option key={file.name} value={file.path}>
                                                                        {file.name}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                            {storageFilesLoading && (
                                                                <Form.Text className="text-muted">
                                                                    Bestanden laden...
                                                                </Form.Text>
                                                            )}
                                                            {fileFormData.fileLink && (
                                                                <Form.Text className="text-muted">
                                                                    Geselecteerd: {fileFormData.fileLink}
                                                                </Form.Text>
                                                            )}
                                                        </Form.Group>

                                                        <div className="text-muted small">
                                                            <strong>UUID:</strong> {fileFormData.uuid}
                                                        </div>

                                                        <hr />

                                                        <div className="d-flex justify-content-end gap-2">
                                                            {files.length > 1 && (
                                                                <Button 
                                                                    variant="danger" 
                                                                    onClick={() => {
                                                                        if (window.confirm('Weet je zeker dat je dit bestand wilt verwijderen?')) {
                                                                            handleDeleteFile(activeFileIndex);
                                                                        }
                                                                    }}
                                                                >
                                                                    Verwijderen
                                                                </Button>
                                                            )}
                                                            <Button 
                                                                variant="primary" 
                                                                onClick={handleSaveFile}
                                                                disabled={savingFile || !fileFormData.uuid}
                                                            >
                                                                {savingFile ? 'Opslaan...' : 'Opslaan'}
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                </Card.Body>
                                            </Card>
                                        </>
                                    ) : (
                                        <div className="text-center p-4">
                                            <p>Geen bestanden gevonden.</p>
                                            <Button variant="primary" onClick={handleAddFile}>
                                                Eerste Bestand Toevoegen
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            </Tab>
                            
                            <Tab eventKey="comments" title={
                                <div style={{ position: 'relative', display: 'inline-block' }}>
                                    Comments ({(() => {
                                        return Object.values(moduleComments).reduce((total, comments) => {
                                            return total + comments.filter(c => !c.deleted).length;
                                        }, 0);
                                    })()})
                                    {(() => {
                                        const totalUnread = Object.values(moduleComments).reduce((total, comments) => {
                                            return total + comments.filter(c => !(c.response || c.notResponding) && !c.deleted).length;
                                        }, 0);
                                        return totalUnread > 0 && (
                                            <span className="badge bg-danger" style={{ position: 'absolute', top: '-16px', right: '-22px' }}>{totalUnread}</span>
                                        );
                                    })()}
                                </div>
                            }>
                                <div className="mt-3">
                                    {modules.length > 0 ? (
                                        <>
                                            {/* Global Comments Filter - applies to all modules */}
                                            <div className="mb-4">
                                                <Form.Switch
                                                    id="comments-filter-switch"
                                                    label="Toon alleen comments waar ik nog niet op gereageerd heb"
                                                    checked={showCommentsFilter}
                                                    onChange={(e) => setShowCommentsFilter(e.target.checked)}
                                                    className="comments-filter-switch"
                                                />
                                                <Form.Switch
                                                    id="deleted-comments-filter-switch"
                                                    label="Toon verwijderde reacties"
                                                    checked={showDeletedComments}
                                                    onChange={(e) => setShowDeletedComments(e.target.checked)}
                                                    className="comments-filter-switch mt-2"
                                                />
                                            </div>

                                            {/* Module Tabs for Comments */}
                                            <div className="mb-3">
                                                <div className="d-flex flex-wrap gap-4">
                                                    {modules.map((module, index) => {
                                                        const moduleCommentsArray = moduleComments[module.uuid] || [];
                                                        const unreadCount = moduleCommentsArray.filter(c => !(c.response || c.notResponding) && !c.deleted).length;
                                                        
                                                        return (
                                                            <Button
                                                                key={module.uuid || index}
                                                                variant={activeCommentModuleIndex === index ? "primary" : "outline-primary"}
                                                                size="sm"
                                                                onClick={() => {
                                                                    setActiveCommentModuleIndex(index);
                                                                    setEditingComment(null);
                                                                    setEditCommentData({});
                                                                }}
                                                                style={{ minWidth: '120px', position: 'relative' }}
                                                            >
                                                                {index + 1}. {module.name}
                                                                {unreadCount > 0 && (
                                                                    <span className="badge bg-danger" style={{ position: 'absolute', top: '-9px', right: '-9px' }}>{unreadCount}</span>
                                                                )}
                                                            </Button>
                                                        );
                                                    })}
                                                </div>
                                            </div>

                                            {/* Comments for Active Module */}
                                            <div style={{gap:'1.5rem', padding:'0rem 0rem'}}>
                                                {(() => {
                                                    const currentModule = modules[activeCommentModuleIndex];
                                                    const currentComments = moduleComments[currentModule?.uuid] || [];
                                                    
                                                    // Comment Statistics for current module
                                                    const unreadCount = currentComments.filter(c => !(c.response || c.notResponding) && !c.deleted).length;
                                                    const activeCount = currentComments.filter(c => !c.deleted).length;
                                                    const deletedCount = currentComments.filter(c => c.deleted).length;
                                                    
                                                    return (
                                                        <>
                                                            {/* Module Comment Statistics */}
                                                            <div className="mb-3 p-2 bg-light rounded">
                                                                <small className="text-muted">
                                                                    Totaal {activeCount} reacties, waarvan {unreadCount} onbeantwoord
                                                                </small>
                                                            </div>
                                                            
                                                            {currentComments.length === 0 ? (
                                                                <div style={{padding: '2rem', textAlign: 'center', color: '#6c757d'}}>
                                                                    Geen comments gevonden voor deze module.
                                                                </div>
                                                            ) : (
                                                                currentComments
                                                        .map((comment, originalIndex) => {
                                                            // Apply filter but keep original index
                                                            if (showCommentsFilter) {
                                                                // Filter out comments that have notResponding=true OR have a response object
                                                                if (comment.notResponding || comment.response) {
                                                                    // But still show if we're editing this comment
                                                                    if (editingComment !== originalIndex) {
                                                                        return null;
                                                                    }
                                                                }
                                                            }
                                                            
                                                            // Filter out deleted comments if showDeletedComments is disabled
                                                            if (!showDeletedComments && comment.deleted) {
                                                                // But still show if we're editing this comment
                                                                if (editingComment !== originalIndex) {
                                                                    return null;
                                                                }
                                                            }
                                                            
                                                            const isEditing = editingComment === originalIndex;
                                                            const commentData = isEditing ? editCommentData : comment;
                                                            
                                                            return (
                                                                <Card 
                                                                    key={comment.uuid || originalIndex} 
                                                                    className={`academy-comment-card ${isEditing ? 'editing' : ''} ${comment.deleted ? 'deleted-comment' : ''}`} 
                                                                    style={{
                                                                        marginBottom: '1.5rem',
                                                                        cursor: (!isEditing && !comment.deleted) ? 'pointer' : 'default',
                                                                        backgroundColor: comment.deleted ? '#ffebee' : undefined,
                                                                        opacity: comment.deleted ? 0.8 : 1,
                                                                        paddingBottom: comment.deleted ? '0.5rem' : undefined
                                                                    }}
                                                                    onClick={(!isEditing && !comment.deleted) ? () => handleCommentClick(comment, originalIndex) : undefined}
                                                                >
                                                                    <Card.Header>
                                                                        <div className="d-flex justify-content-between align-items-start">
                                                                            <div>
                                                                                {commentData.pinned && (
                                                                                    <Card.Text className="pinned">
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" focusable="false" aria-hidden="true">
                                                                                            <path d="M16 11V3h1V2H7v1h1v8l-2 2v2h5v6l1 1 1-1v-6h5v-2l-2-2zm1 3H7v-.59l1.71-1.71.29-.29V3h6v8.41l.29.29L17 13.41V14z"></path>
                                                                                        </svg>
                                                                                        <span></span>
                                                                                        Pinned by Marloes
                                                                                    </Card.Text>
                                                                                )}
                                                                                <Card.Text>
                                                                                    <b>{commentData.user || 'Anoniem'}</b> 
                                                                                    <span style={{fontSize:'0.7rem',color:'gray', paddingLeft:'0.5rem'}}>
                                                                                        {formatTimestamp(commentData.timestamp)}
                                                                                    </span>
                                                                                    {commentData.deleted && (
                                                                                        <span style={{fontSize:'0.7rem', color:'#d32f2f', paddingLeft:'0.5rem', fontWeight:'bold'}}>
                                                                                            • VERWIJDERD DOOR KLANT
                                                                                        </span>
                                                                                    )}
                                                                                </Card.Text>
                                                                            </div>
                                                                            <div className="d-flex gap-2" onClick={(e) => e.stopPropagation()}>
                                                                                {commentData.deleted && (
                                                                                    <>
                                                                                        <Button 
                                                                                            variant="success" 
                                                                                            size="sm"
                                                                                            onClick={() => handleUndeleteComment(originalIndex)}
                                                                                            disabled={savingComment}
                                                                                            style={{height:'20px', padding: '0 0.5rem', fontSize:'0.7rem'}}
                                                                                        >
                                                                                            {savingComment ? 'Herstellen...' : 'Herstellen'}
                                                                                        </Button>
                                                                                        <Button 
                                                                                            variant="danger" 
                                                                                            size="sm"
                                                                                            onClick={() => handlePermanentDeleteComment(originalIndex)}
                                                                                            disabled={savingComment}
                                                                                            style={{height:'20px', padding: '0 0.5rem', fontSize:'0.7rem'}}
                                                                                            title="Permanent verwijderen uit database"
                                                                                        >
                                                                                            Verwijderen
                                                                                        </Button>
                                                                                    </>
                                                                                )}
                                                                                {isEditing && (
                                                                                    <>
                                                                                        <Form.Switch
                                                                                            id={`pin-switch-${originalIndex}`}
                                                                                            label="Pin"
                                                                                            checked={commentData.pinned || false}
                                                                                            onChange={() => handleCommentToggle('pinned')}
                                                                                            style={{ fontSize: '0.8rem' }}
                                                                                        />
                                                                                        <Form.Switch
                                                                                            id={`not-responding-switch-${originalIndex}`}
                                                                                            label="Niet reageren"
                                                                                            checked={commentData.notResponding || false}
                                                                                            onChange={() => handleCommentToggle('notResponding')}
                                                                                            style={{ fontSize: '0.8rem' }}
                                                                                            title="Markeer als gelezen maar kies ervoor om niet te reageren"
                                                                                        />
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </Card.Header>
                                                                    <Card.Body>
                                                                        {isEditing ? (
                                                                            <Form.Control
                                                                                as="textarea"
                                                                                rows={3}
                                                                                value={commentData.comment || ''}
                                                                                onChange={(e) => handleCommentInputChange(e, 'comment')}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                                placeholder="Comment..."
                                                                            />
                                                                        ) : (
                                                                            commentData.comment
                                                                        )}
                                                                    </Card.Body>
                                                                    {(commentData.response || isEditing) && (
                                                                        <Card.Footer onClick={(e) => e.stopPropagation()}>
                                                                            <Card className='academy-comment-card comment-response'>
                                                                                <Card.Header>
                                                                                    <Card.Text>
                                                                                        <b>Marloes Vogel</b> 
                                                                                        <span style={{fontSize:'0.7rem',color:'gray', paddingLeft:'0.5rem'}}>
                                                                                            {formatTimestamp(commentData.response?.timestamp)}
                                                                                        </span>
                                                                                        {isEditing && !commentData.response?.comment && (
                                                                                            <span style={{fontSize:'0.7rem',color:'#6c757d', paddingLeft:'0.5rem'}}>
                                                                                                - Je reactie
                                                                                            </span>
                                                                                        )}
                                                                                    </Card.Text>
                                                                                </Card.Header>
                                                                                <Card.Body>
                                                                                    {isEditing ? (
                                                                                        <Form.Control
                                                                                            as="textarea"
                                                                                            rows={3}
                                                                                            value={commentData.response?.comment || ''}
                                                                                            onChange={(e) => handleCommentInputChange(e, 'comment', true)}
                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                            placeholder="Voeg je reactie toe..."
                                                                                        />
                                                                                    ) : (
                                                                                        commentData.response?.comment
                                                                                    )}
                                                                                </Card.Body>
                                                                            </Card>
                                                                        </Card.Footer>
                                                                    )}
                                                                    {isEditing && (
                                                                        <Card.Footer onClick={(e) => e.stopPropagation()}>
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <small className="text-muted">Ctrl+S om op te slaan</small>
                                                                                <div className="d-flex gap-2">
                                                                                    <Button 
                                                                                        variant="outline-secondary" 
                                                                                        size="sm"
                                                                                        onClick={() => {
                                                                                            setEditingComment(null);
                                                                                            setEditCommentData({});
                                                                                        }}
                                                                                    >
                                                                                        Annuleren
                                                                                    </Button>
                                                                                    <Button 
                                                                                        variant="danger" 
                                                                                        size="sm"
                                                                                        onClick={handleDeleteComment}
                                                                                    >
                                                                                        Verwijderen
                                                                                    </Button>
                                                                                    <Button 
                                                                                        variant="primary" 
                                                                                        size="sm"
                                                                                        onClick={handleSaveComment}
                                                                                        disabled={savingComment}
                                                                                    >
                                                                                        {savingComment ? 'Opslaan...' : 'Opslaan'}
                                                                                    </Button>
                                                                                </div>
                                                                            </div>
                                                                        </Card.Footer>
                                                                    )}
                                                                </Card>
                                                            );
                                                        })
                                                        .filter(Boolean)
                                                            )}
                                                        </>
                                                    );
                                                })()}
                                            </div>
                                        </>
                                    ) : (
                                        <p>Geen modules gevonden.</p>
                                    )}
                                </div>
                            </Tab>
                        </Tabs>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-between align-items-center">
                        <div>
                            <Form.Switch
                                id="enabled-switch"
                                label={formData.enabled ? 'Serie zichtbaar op Academy' : 'Serie niet zichtbaar op Academy'}
                                checked={formData.enabled}
                                onChange={handleEnabledToggle}
                                className={`custom-switch-large ${formData.enabled ? 'text-success' : 'text-danger'}`}
                                style={{ fontSize: '0.7rem !important' }}
                            />
                        </div>
                        <div className="d-flex align-items-center">
                            <Form.Switch
                                id="delete-enable-switch"
                                label=""
                                checked={deleteEnabled}
                                onChange={(e) => setDeleteEnabled(e.target.checked)}
                                className="me-2"
                                title="Schakel in om verwijderen toe te staan"
                                style={{ 
                                    fontSize: '0.7rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginBottom: '0'
                                }}
                            />
                            <Button 
                                variant="danger" 
                                onClick={handleDeleteSeries}
                                disabled={!deleteEnabled || saving}
                                title="Serie permanent verwijderen"
                                style={{ marginRight: '3rem' }}
                            >
                                Verwijderen
                            </Button>
                            <Button variant="secondary" onClick={handleClose} className="me-2">
                                Annuleren
                            </Button>
                            <Button variant="primary" onClick={handleSave} disabled={saving}>
                                {saving ? 'Opslaan...' : 'Opslaan'}
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </Stack>
            
            {/* Asset Picker Dialogs */}
            <UkiesAssets
                open={showThumbnailAssets}
                setOpen={setShowThumbnailAssets}
                onAssetSelect={handleThumbnailAssetSelect}
                token={apiToken}
            />
            
            <UkiesAssets
                open={showImageAssets}
                setOpen={setShowImageAssets}
                onAssetSelect={handleImageAssetSelect}
                token={apiToken}
            />
            
            <UkiesAssets
                open={showModuleThumbnailAssets}
                setOpen={setShowModuleThumbnailAssets}
                onAssetSelect={handleModuleThumbnailAssetSelect}
                token={apiToken}
            />
            
            <UkiesAssets
                open={showFileThumbnailAssets}
                setOpen={setShowFileThumbnailAssets}
                onAssetSelect={handleFileThumbnailAssetSelect}
                token={apiToken}
            />

            {/* Preview Modal */}
            <Modal show={showPreviewModal} onHide={() => setShowPreviewModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Preview Image</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <img src={previewImage} alt="Preview" style={{ width: '100%', maxHeight: '80vh', objectFit: 'contain' }} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowPreviewModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>

    );
}